/* MV Sortiment assets/mv-sortiment.finvergleich.js · Agent W-F · 2026-10-07 */
/*
  Finanzierungsvergleich (Paket W-F): Kauf, Leasing, Mietkauf und Miete nebeneinander, mit einstellbaren Annahmen,
  Kurve der kumulierten Kosten, grobem Steuereffekt und einer Entscheidungshilfe aus drei Fragen.
  Markup: sections/mv-finanzierungsvergleich.liquid; Rechenregeln, Annahmen mit Herkunft und offene Inhaberfragen:
  _docs/wf-finvergleich.md; Tests: _tests/wf-finvergleich.test.mjs.

  Teil 1 - reine Logik ohne DOM (unter Node auf module.exports):
    - Annahmen: Standardwerte (STANDARD = Schema-Standards der Sektion), Settings aus dem JSON-Datenblock (basisAus),
      eigene Werte des Nutzers je Laufzeit (annahmenFuer); Nutzungsdauer nach Geraetetyp (AfA-Tabelle).
    - rechne(): je Weg Monatsbelastung, Summe ueber die Laufzeit, Mehrkosten gegenueber dem Kauf, Bindung im ersten
      Monat, Gleichstand mit dem Kaufpreis, Eigentum, Betriebsausgaben, Steuerersparnis und Kosten nach Steuern (grob).
        Kauf      Preis zu Beginn; AfA linear Preis / (Nutzungsdauer x 12) je Monat, in der Laufzeit hoechstens alles.
        Leasing   Rate = (Preis - Anzahlung) x Leasingfaktor; Anzahlung und Raten sind Betriebsausgaben.
        Mietkauf  Annuitaet mit effektivem Jahreszins auf (Preis - Anzahlung); AfA wie Kauf plus Zinsanteil.
        Miete     Rate = Preis x Mietfaktor; Betriebsausgabe.
    - kurve(), achse(): kumulierte Kosten je Monat (linear, monoton) und runde Achsenmarken.
    - empfehlung(): drei Antworten -> genau ein Weg mit Alternative (acht Kombinationen, EMPFEHLUNGEN).
    - Geraete aus dem Datenblock (geraeteOptionen), Zustand im Hash #fv=1:... (kodiere/dekodiere), Texte fuer Karten,
      Kurve, Tabelle, Kurzfassung (data-konfiguration) und Nachricht (data-nachricht) der Anfrage-Lightbox.
  Teil 2 - Browser: Waechter window.__mvSortiment.finvergleich, Wurzel [data-mv-finv], Delegation auf document (auch
    shopify:section:load), Druck ueber beforeprint/afterprint und Groesse ueber resize auf window. Zustand per
    history.replaceState im Hash und im localStorage (Schluessel SPEICHER), Texte nur per textContent, Kurve als SVG
    ohne Bibliothek (Fadenkreuz mit Zeiger und Tastatur), Analytics finanzierungsvergleich_cta und
    finanzierungsvergleich_empfehlung.
  Sichtbare Texte in TEXTE, Umlaute als \u-Escapes (Datei bleibt ASCII). Zahlen nennt das Skript nur als Rechenwerte im
  Rechner-Ergebnis ([data-mv-rechner-ergebnis], Pruefregel Z-06).
  Nachtrag K-2 (07.10.2026, _docs/k2-werkzeuge.md): Leasingrate nie unter der Mindestrate der Partnerbank
  (LEASING_MINDESTRATE, "Leasing ab 100 EUR / Monat", Faktenliste Nr. 8) mit Hinweis auf der Leasing-Karte; Sprunglinks
  setzen den Fokus auf den Zielabschnitt (Ueberschrift mit tabindex -1 bzw. summary, preventScroll); der Monat der Kurve
  wird bei Tastaturbedienung ueber die immer vorhandene Live-Region [data-mv-finv-kurve-ansage] angesagt.
  Nachtrag D-W2 (08.10.2026, _docs/dw2-nacharbeiten.md; offener Punkt aus _docs/dw-werkzeuge.md Abschnitt 9): Die
  Beschriftung der Kurve folgt der Typo-Skala der Werkzeuge, 14 px mobil, 15 px ab 1000 px, 16 px ab 1280 px (Token
  --mvs-finv-fs-grafik an der Kurvenflaeche). kurveZeichnen liest die Groesse an der Flaeche (grafikSchrift), schreibt
  sie als font-size an das SVG (die Texte erben sie, Geometrie und Schrift passen immer zusammen) und rechnet Raender,
  Abstaende und Hoehe mit kurvenMasse: Achsenwerte und Endmarken nach ihrer Breite (textBreite, obere Schranke fuer
  Barlow), Abstand der Endmarken 4/3 der Schrift, Monate und Achsentitel darunter; die Zeichenflaeche bleibt 192 px
  (mobil) bzw. 248 px hoch. Neu gezeichnet wird auch, wenn sich nur die Schrift aendert.
  Nachtrag K-A (08.10.2026, _docs/ka-kosmetik.md; Screenshot-Runde r18b: die Grundflaeche des Achsenwerts "2.500 EUR"
  unterbrach die Linie Miete, die von "5.000 EUR" verdeckte den Anfang der Linie Kauf): Mobil stehen die Achsenwerte
  vor den Linien im SVG, die Linien laufen also darueber und werden nie verdeckt. achsenLage legt alle Werte auf
  dieselbe Seite ihrer Gitterlinien (darueber oder darunter), auf der weniger Linie durch die Ziffern laeuft (bei
  Gleichstand darueber).
  Nachtrag F-3a (08.10.2026, _docs/f3-finanzierung.md; Inhaber: "Fuer alle Produkte ausser den X10 bieten wir nur Kauf
  und Leasing an" und "Leasingfaktor in Hoehe 2,09%, Laufzeit 54 Monate und 15% Restwert ist so ein Rahmen den wir bei
  der Leasing Bank haben"): Laufzeiten 36/48/54/60, Standard 54 Monate; Leasingfaktoren aus dem Rahmen der Partnerbank
  (RAHMEN, abgeleiteterFaktor: gleicher Monatszins 0,839 %, Raten nachschuessig, Restwert 15 %), Restwert 15 %.
  Wege je Familie (wegeFuer): X10 Dual Screen Kauf, Leasing, Mietkauf und Miete; SandenVendo und eigener Geraetepreis
  nur Kauf und Leasing. rechne(a, wege) rechnet weiter alle vier Wege, Rangfolge, Summen, Kurve, Tabelle, Tooltip,
  Kurzfassung und Nachricht nennen nur die Wege des Geraets; im DOM tragen Karten, Legende, Tabellenspalten und die
  Annahmen Mietkauf/Miete [data-mv-finv-nur-x10]. Entscheidungshilfe: Empfehlung immer Kauf (mit Eigenkapital) oder
  Leasing (ohne), Mietkauf und Miete nur als Alternative beim X10 ("auf Anfrage"). Hash: l54 neu, l36/l48/l60 bleiben.
  Der Leasingfaktor steht in Texten und im Feld mit bis zu drei Nachkommastellen (faktorText, zahlFaktor), wie gerechnet.
  Nachtrag A-2b (10.10.2026, _docs/a2b-konto-werkzeuge.md): Der Zustand speichert ueber das Kundenkonto
  (assets/mv-sortiment.konto.js, MVKonto) unter dem Werkzeug-Schluessel "finvergleich": Stand { v: 1, code, titel }
  (code = derselbe Text wie im Hash, fv=1:...; titel = Geraet und Laufzeit fuer "Meine Werkzeuge"). Ohne Login wie
  bisher nur im Browser (Spiegel mv-konto:finvergleich statt SPEICHER), mit Login zusaetzlich im Konto; der
  Altschluessel SPEICHER wandert einmalig in den Spiegel (MVKonto.migration). Beim Laden gilt weiter Hash vor Speicher
  vor Standard. Gespeichert wird wie bisher erst nach einer Aenderung (zustandSchreiben), gleicher Stand speichert
  nichts. Mit Login zeigt die Seite einen abweichenden Konto-Stand (anderes Geraet, im Konto geloescht), solange sie
  nicht aus einem Link kam und noch nichts geaendert wurde; sonst gilt die Seite und geht ins Konto. Statuszeile am
  Ende des Kopftexts (.mv-finv-kopf__text): die Sektion bleibt unveraendert (sie steht in den md5-Ketten von T-6),
  MVKonto baut die Zeile dort selbst; rendert die Sektion spaeter das Snippet mv-konto-hinweis, wird dieses gebunden.
  konto.js steht im Buendel nach dieser Datei: der Start laeuft deshalb wie bei A-2a per Mikrotask nach dem ganzen
  Buendel (nachBuendel, vor dem naechsten Zeichnen). Mit MVKonto wird nur dort gespeichert (Plan, Vertrag
  Abschnitt 3); ohne MVKonto (Rueckfall) wie vor A-2b unter SPEICHER.
  Nachtrag F-4 (10.10.2026, _docs/f4-mindestrate.md; Inhaber 09.10.2026 zur Inhaberfrage 311 "Mindestrate 100 EUR im
  Monat - gilt sie fuer alle Geraete und Laufzeiten?": "Das gilt fuer Snackautomaten, ist ok wenn andere guenstiger
  sind."): Die Mindestrate der Partnerbank gilt nur fuer Standautomaten. Die Regel steht an einer Stelle (Teil 1,
  exportiert, im Browser unter window.__mvSortiment.finvergleich): istTischgeraet() erkennt Tischgeraete (Kennzeichen
  tisch, Tag bauform:tischgeraet, Produkttyp Tischautomat, Typ tisch, Tag familie:uno, sonst Handle oder Name einer
  Tischgeraete-Baureihe aus TISCHGERAETE: SnackUNO, UnoCool, CaffeUNO, UNOffice), mindestrateFuer() liefert 100 bzw. 0,
  leasingRate() rechnet Rate = Betrag x Faktor und hebt nur bis zur Mindestrate des Geraets an. rechne(a, wege,
  mindestrate) nimmt die Mindestrate des Geraets (ohne Angabe wie bis F-4: 100); der Vergleich gibt sie je Option
  (Typ, Handle und Titel aus dem Datenblock), beim Standardgeraet aus dem Namen und beim eigenen Geraetepreis die der
  Standautomaten. Hinweis auf der Leasing-Karte: TEXTE.mindestrate (Standautomat unter 100 EUR, angehoben) bzw.
  TEXTE.ohneMindestrate (Tischgeraet unter 100 EUR). Dieselbe Regel nutzen der Businessplan
  (assets/mv-sortiment.businessplan.js) und in Liquid snippets/mv-bauform.liquid (Kaufbox).
*/
/* Nachtrag F-5 (03.11.2026, _docs/f5-mindestrate.md; Inhaber 12.10.2026 zur Inhaberfrage 561: "Nein, der Bank ist das
   egal, koennen auch unter 100 Euro sein"): Es gibt keine Mindestrate der Partnerbank; jede Leasingrate ist Betrag x
   Faktor. mindestrateFuer() liefert fuer jedes Geraet 0, leasingRate() hebt nie an (angehoben und ohneMindestrate immer
   false), Vergleich.prototype.mindestrate() 0; Signaturen und Exporte (LEASING_MINDESTRATE = 100 als Einstiegsangabe der
   Snackautomaten, TISCHGERAETE, istTischgeraet, mindestrateFuer, leasingRate) bleiben fuer den Businessplan und aeltere
   Aufrufer. Die Hinweise TEXTE.mindestrate und TEXTE.ohneMindestrate auf der Leasing-Karte entfallen; die Nachtraege K-2
   und F-4 oben beschreiben den Stand davor. */
(function () {
  'use strict';

  var VERSION = '2026-10-08.1';

  // ===========================================================================================
  // Teil 1: Logik
  // ===========================================================================================

  var LAUFZEITEN = [36, 48, 54, 60];
  var VARIANTEN = ['kauf', 'leasing', 'mietkauf', 'miete'];
  var NAMEN = { kauf: 'Kauf', leasing: 'Leasing', mietkauf: 'Mietkauf', miete: 'Miete' };
  var ARTIKEL = { kauf: 'der Kauf', leasing: 'das Leasing', mietkauf: 'der Mietkauf', miete: 'die Miete' };
  var FRAGEN = ['eigenkapital', 'lang', 'flexibel'];
  // F-3a: Rahmen der Partnerbank (Inhaber 08.10.2026, Faktenliste Nr. 8): Faktor in % des Nettopreises je Monat bei
  // dieser Laufzeit und diesem Restwert in %; die uebrigen Laufzeiten leitet abgeleiteterFaktor daraus ab
  var RAHMEN = { laufzeit: 54, faktor: 2.09, restwert: 15 };
  // Wege je Familie (Faktenliste Nr. 9): Miete und Mietkauf nur beim X10 Dual Screen, auf Anfrage
  var WEGE = { x10: ['kauf', 'leasing', 'mietkauf', 'miete'], sandenvendo: ['kauf', 'leasing'] };
  var NUR_X10 = ['mietkauf', 'miete'];
  // Standardwerte = Schema-Standards der Sektion (Test); Herkunft und Inhaberfragen: _docs/wf-finvergleich.md und
  // _docs/f3-finanzierung.md (Leasingfaktoren und Restwert aus dem Rahmen der Partnerbank, Inhaberfrage 310)
  var STANDARD = {
    geraetName: 'X10 Dual Screen Lite',
    preis: 5900,
    laufzeit: 54,
    anzahlung: 0,
    leasingFaktor: { 36: 2.871, 48: 2.285, 54: 2.09, 60: 1.935 },
    restwert: 15,
    mietkaufZins: 9,
    mieteFaktor: 3.5,
    steuersatz: 30,
    nutzungsdauer: 5,
    nutzungsdauerGetraenke: 7
  };
  var GRENZEN = {
    preis: [0, 1000000],
    anzahlung: [0, 90],
    leasingFaktor: [0, 20],
    restwert: [0, 90],
    mietkaufZins: [0, 30],
    mieteFaktor: [0, 20],
    steuersatz: [0, 60],
    nutzungsdauer: [1, 30]
  };
  var ANNAHMEN = ['anzahlung', 'leasingFaktor', 'restwert', 'mietkaufZins', 'mieteFaktor', 'steuersatz', 'nutzungsdauer'];
  // Kuerzel im Hash; der Leasingfaktor steht je Laufzeit als l36, l48, l54, l60 (l54 seit F-3a, aeltere Links lesbar)
  var HASH_CODES = { anzahlung: 'an', restwert: 'rw', mietkaufZins: 'mz', mieteFaktor: 'mf', steuersatz: 'st', nutzungsdauer: 'nd' };
  // Interesse der Lightbox: Mietkauf wie der Umschalter "Mieten / Mietkauf" der Seite (sections/mv-finanzierung.liquid)
  var INTERESSE = { kauf: 'Kauf', leasing: 'Leasing', mietkauf: 'Miete', miete: 'Miete' };
  var INTERESSE_OHNE = 'Leasing';
  // Antworten eigenkapital, lang, flexibel als j/n -> [Empfehlung, Alternative] beim X10 Dual Screen (vier Wege).
  // F-3a (Inhaber 08.10.2026: "am liebsten ... Leasing oder Kauf"): empfohlen wird immer Kauf (mit Eigenkapital) oder
  // Leasing (ohne); Mietkauf und Miete erscheinen nur als Alternative. Bis F-3a empfahl die Tabelle bei jnj und nnj die
  // Miete und bei njn den Mietkauf.
  var EMPFEHLUNGEN = {
    jjn: ['kauf', 'mietkauf'],
    jjj: ['kauf', 'leasing'],
    jnn: ['kauf', 'leasing'],
    jnj: ['kauf', 'miete'],
    njn: ['leasing', 'mietkauf'],
    njj: ['leasing', 'mietkauf'],
    nnn: ['leasing', 'miete'],
    nnj: ['leasing', 'miete']
  };
  var GRUPPEN = [
    ['x10', 'X10 Dual Screen'],
    ['snack', 'Snackautomaten'],
    ['kombi', 'Kombiautomaten'],
    ['getraenke', 'Getr\u00e4nkeautomaten'],
    ['kaffee', 'Kaffeeautomaten'],
    ['tiefkuehl', 'Tiefk\u00fchlautomaten'],
    ['tisch', 'Tischger\u00e4te'],
    ['micro-market', 'Micro-Market'],
    ['sonst', 'Weitere Ger\u00e4te']
  ];
  var TABELLE_MONATE = [0, 1, 12, 24, 36, 48, 60];
  // Leasing-Hinweis, wenn die Laufzeit ausserhalb 40 bis 90 % der Nutzungsdauer liegt (Doku Abschnitt 3.4)
  var LEASING_RAHMEN = [0.4, 0.9];
  // Einstiegsangabe der Snackautomaten: "Leasing ab 100 EUR / Monat" (Faktenliste Nr. 8, Pruefregel Z-06). Seit F-5
  // (03.11.2026) keine Mindestrate der Partnerbank: der Vergleich rechnet jede Rate aus den Annahmen (bis F-5 hob er
  // kleinere Raten auf diese Untergrenze an, K-2); Name und Export bleiben
  var LEASING_MINDESTRATE = 100;
  // F-4 (seit F-5 ohne Wirkung auf die Rate, nur noch Kennzeichen tisch im Datenblock und im Export): Tischgeraete laut Katalog
  // (katalog.ts tisch: true, Kollektion tischgeraete, Tag familie:uno) als Handles und Baureihen, solange der Datenblock
  // kein eigenes Kennzeichen traegt (Nachtrag Katalog: Tag bauform:tischgeraet, _docs/f4-mindestrate.md Abschnitt 10)
  var TISCHGERAETE = {
    handles: ['sandenvendo-snackuno', 'sandenvendo-unocool', 'sandenvendo-caffeuno', 'sandenvendo-unoffice', 'sandenvendo-unocool-slave'],
    baureihen: ['SnackUNO', 'UnoCool', 'Caff\u00e8UNO', 'UNOffice']
  };
  var TISCH_NAME = /(?:^|[^a-z0-9\u00e0-\u00ff])(?:snackuno|unocool|caff[e\u00e8]uno|unoffice)(?![a-z0-9])/i;
  var SPEICHER = 'mv-finv:v1';
  var HASH_PRAEFIX = 'fv=1:';
  var KURZ_MAX = 900;
  var NACHRICHT_MAX = 2000;

  var TEXTE = {
    nbsp: '\u00a0',
    euro: '\u20ac',
    ca: '\u2248',
    minus: '\u2212',
    strich: '\u2013',
    trenner: ' \u00b7 ',
    keineRate: 'keine Rate',
    einmalig: 'einmalig',
    imMonat: 'im Monat',
    jeMonat: 'je Monat',
    imJahr: 'im Jahr',
    netto: 'netto',
    nichtInLaufzeit: 'nicht in der Laufzeit',
    sofort: 'sofort',
    nach: 'nach',
    start: 'Start',
    monat: 'Monat',
    monate: 'Monate',
    monaten: 'Monaten',
    jahr: 'Jahr',
    jahre: 'Jahre',
    eigentum: {
      kauf: 'Ja, ab dem ersten Tag',
      leasingVor: 'Nein \u2013 \u00dcbernahme zum Restwert',
      leasingNach: ', wenn Ihr Vertrag sie vorsieht',
      mietkauf: 'Ja, mit der letzten Rate',
      miete: 'Nein \u2013 Sie geben das Ger\u00e4t zur\u00fcck'
    },
    restbuchwertVor: 'Restbuchwert am Ende',
    restbuchwertNach: ' \u2013 die Abschreibung l\u00e4uft danach weiter.',
    leasingLang: 'Die Laufzeit liegt nahe an der Nutzungsdauer. Ob die Raten dann voll als Betriebsausgabe gelten, pr\u00fcft Ihr Steuerberater.',
    leasingKurz: 'Die Laufzeit ist kurz im Verh\u00e4ltnis zur Nutzungsdauer. Ob die Raten dann voll als Betriebsausgabe gelten, pr\u00fcft Ihr Steuerberater.',
    // F-5 (03.11.2026): die Hinweise mindestrate und ohneMindestrate entfallen (keine Mindestrate der Partnerbank)
    annahmenVor: 'Gerechnet mit Annahmen:',
    geraetepreis: 'Ger\u00e4tepreis',
    laufzeit: 'Laufzeit',
    anzahlung: 'Anzahlung',
    leasingfaktor: 'Leasingfaktor',
    restwert: 'Restwert',
    zinsMietkauf: 'Zins Mietkauf',
    miete: 'Miete',
    steuersatz: 'Steuersatz',
    abschreibung: 'Abschreibung \u00fcber',
    nutzungsdauer: 'Nutzungsdauer',
    gesamtkostenIn: 'Gesamtkosten in',
    beiIhrenAnnahmen: 'bei Ihren Annahmen, netto:',
    auchGeringste: 'hat dabei auch die geringsten Gesamtkosten.',
    geringsteVor: 'Die geringsten Gesamtkosten hat bei Ihren Annahmen',
    geringsteNach: '; die Empfehlung ber\u00fccksichtigt zus\u00e4tzlich Kapital, Nutzungsdauer und Flexibilit\u00e4t.',
    alternative: 'Alternative:',
    kurveTitel: 'Kumulierte Kosten \u00fcber die Laufzeit, netto',
    kurveNach: 'Kumulierte Kosten nach',
    kurveVerlauf: 'Der Kauf bleibt nach der Anschaffung gleich, die \u00fcbrigen Wege steigen mit jeder Rate.',
    kurveLeer: 'Die Kurve erscheint, sobald der Vergleich gerechnet hat.',
    achseMonate: 'Monate',
    produktOhne: 'Finanzierungsvergleich',
    eigenerPreis: 'Eigener Ger\u00e4tepreis',
    linkKopiert: 'Link kopiert.',
    linkManuell: 'Bitte kopieren Sie den Link aus der Adresszeile Ihres Browsers.',
    kurzTitel: 'Finanzierungsvergleich',
    kurzGeraet: 'Ger\u00e4t:',
    kurzPreis: 'Ger\u00e4tepreis:',
    kurzLaufzeit: 'Laufzeit:',
    kurzEmpfehlung: 'Empfehlung:',
    kurzAnzahlung: 'Anzahlung:',
    kurzAnnahmen: 'Annahmen:',
    nachrichtGruss: 'Guten Tag,',
    nachrichtBitte: 'bitte senden Sie mir ein Angebot mit Finanzierung.',
    nachrichtEmpfehlung: 'Empfehlung aus dem Finanzierungsvergleich:',
    nachrichtVergleich: 'Mein Vergleich mit Annahmen, netto:',
    nachrichtGesamt: 'gesamt',
    nachrichtLink: 'Link zum Vergleich:',
    punkt: '\u2013 ',
    // F-3a: Hinweise zu den Wegen je Familie (Faktenliste Nr. 9); wortgleich im Server-HTML der Sektion
    wegeHinweis: 'F\u00fcr SandenVendo-Ger\u00e4te bieten wir Kauf und Leasing an. Miete und Mietkauf gibt es nur f\u00fcr den X10 Dual Screen auf Anfrage.',
    eigenHinweis: 'F\u00fcr einen eigenen Ger\u00e4tepreis vergleichen wir Kauf und Leasing. Miete und Mietkauf gibt es nur f\u00fcr den X10 Dual Screen auf Anfrage \u2013 w\u00e4hlen Sie ihn oben aus, um alle vier Wege zu sehen.',
    x10Marke: 'Nur X10 Dual Screen \u00b7 auf Anfrage',
    aufAnfrage: ' (auf Anfrage)',
    // Begruendung je Antwort-Kombination und Text je moeglicher Alternative (vier Wege beim X10, sonst Kauf und Leasing)
    empfehlung: {
      jjn: {
        grund: 'Sie haben das Kapital und nutzen das Ger\u00e4t l\u00e4nger als f\u00fcnf Jahre. Beim Kauf zahlen Sie keine Finanzierungskosten, das Ger\u00e4t geh\u00f6rt Ihnen ab dem ersten Tag, und nach der Anschaffung fallen keine Raten mehr an.',
        alternativen: {
          mietkauf: 'wenn Sie Ihr Kapital lieber f\u00fcr Ware oder ein zweites Ger\u00e4t behalten und am Ende trotzdem Eigent\u00fcmer sein m\u00f6chten.',
          leasing: 'wenn Sie Ihr Kapital lieber f\u00fcr Ware oder ein zweites Ger\u00e4t behalten m\u00f6chten; am Ende der Laufzeit \u00fcbernehmen Sie das Ger\u00e4t zum Restwert, wenn Ihr Vertrag es vorsieht.'
        }
      },
      jjj: {
        grund: 'Sie haben das Kapital und nutzen das Ger\u00e4t lange. Ein eigenes Ger\u00e4t stellen Sie an einem neuen Standort auf oder verkaufen es, wann Sie m\u00f6chten \u2013 ohne laufenden Vertrag.',
        alternativen: {
          leasing: 'wenn Sie Ihr Kapital schonen und am Ende der Laufzeit neu entscheiden m\u00f6chten.'
        }
      },
      jnn: {
        grund: 'Sie haben das Kapital und brauchen keine besondere Flexibilit\u00e4t. Ohne Finanzierungskosten hat der Kauf in der Regel die geringsten Gesamtkosten; nach der Nutzung k\u00f6nnen Sie das Ger\u00e4t verkaufen.',
        alternativen: {
          leasing: 'wenn Ihr Kapital lieber in Ware oder ein zweites Ger\u00e4t flie\u00dfen soll.'
        }
      },
      jnj: {
        grund: 'Sie haben das Kapital und m\u00f6chten flexibel bleiben, etwa f\u00fcr einen Standortwechsel. Ein eigenes Ger\u00e4t stellen Sie an einem neuen Standort auf oder verkaufen es, wann Sie m\u00f6chten \u2013 ohne laufenden Vertrag und ohne Finanzierungskosten.',
        alternativen: {
          miete: 'wenn Sie den X10 Dual Screen nur f\u00fcr eine begrenzte Zeit nutzen und danach zur\u00fcckgeben m\u00f6chten; Laufzeit und Mindestmietdauer nennen wir im Angebot.',
          leasing: 'wenn Sie Ihr Kapital schonen und am Ende der Laufzeit neu entscheiden m\u00f6chten.'
        }
      },
      njn: {
        grund: 'Sie m\u00f6chten ohne Eigenkapital starten und das Ger\u00e4t lange nutzen. Beim Leasing zahlen Sie Raten statt des Kaufpreises; am Ende der Laufzeit \u00fcbernehmen Sie das Ger\u00e4t zum Restwert, wenn Ihr Vertrag es vorsieht.',
        alternativen: {
          mietkauf: 'wenn Sie mit der letzten Rate sicher Eigent\u00fcmer werden m\u00f6chten.',
          kauf: 'wenn Sie den Kaufpreis doch aufbringen: Dann zahlen Sie keine Finanzierungskosten, und das Ger\u00e4t geh\u00f6rt Ihnen ab dem ersten Tag.'
        }
      },
      njj: {
        grund: 'Sie starten ohne Eigenkapital, m\u00f6chten das Ger\u00e4t lange nutzen und dabei flexibel bleiben. Beim Leasing zahlen Sie Raten statt des Kaufpreises und entscheiden am Ende der Laufzeit, ob Sie das Ger\u00e4t zur\u00fcckgeben oder \u2013 wenn Ihr Vertrag es vorsieht \u2013 \u00fcbernehmen.',
        alternativen: {
          mietkauf: 'wenn Sie das Ger\u00e4t am Ende sicher besitzen m\u00f6chten.',
          kauf: 'wenn Sie den Kaufpreis doch aufbringen: Dann zahlen Sie keine Finanzierungskosten, und das Ger\u00e4t geh\u00f6rt Ihnen ab dem ersten Tag.'
        }
      },
      nnn: {
        grund: 'Sie starten ohne Eigenkapital und nutzen das Ger\u00e4t f\u00fcr eine feste Zeit. Beim Leasing zahlen Sie Raten statt des Kaufpreises; Leasingraten sind in der Regel als Betriebsausgabe absetzbar \u2013 Einzelheiten kl\u00e4rt Ihr Steuerberater.',
        alternativen: {
          miete: 'wenn Sie sich nicht auf eine feste Laufzeit festlegen m\u00f6chten.',
          kauf: 'wenn Sie den Kaufpreis doch aufbringen: Ein eigenes Ger\u00e4t verkaufen Sie, wann Sie m\u00f6chten, ohne laufenden Vertrag.'
        }
      },
      nnj: {
        grund: 'Sie starten ohne Eigenkapital und brauchen Flexibilit\u00e4t, etwa f\u00fcr einen Standortwechsel. Beim Leasing binden Sie kein Kapital und zahlen Raten statt des Kaufpreises; was am Ende der Laufzeit gilt, regelt Ihr Leasingvertrag.',
        alternativen: {
          miete: 'wenn Sie den X10 Dual Screen nach der Mindestmietdauer zur\u00fcckgeben m\u00f6chten; Laufzeit und Mindestmietdauer nennen wir im Angebot.',
          kauf: 'wenn Sie den Kaufpreis doch aufbringen: Ein eigenes Ger\u00e4t stellen Sie um oder verkaufen es, wann Sie m\u00f6chten.'
        }
      }
    }
  };

  function hat(o, k) {
    return !!o && Object.prototype.hasOwnProperty.call(o, k);
  }

  function istObjekt(x) {
    return !!x && typeof x === 'object' && !Array.isArray(x);
  }

  // Zahl aus Zahl oder Text (Punkt oder Komma als Dezimaltrenner); sonst NaN
  function zahl(x) {
    if (typeof x === 'number') return x;
    if (typeof x !== 'string') return NaN;
    var t = x.replace(/\u00a0/g, '').trim();
    if (!/^-?\d+(?:[.,]\d+)?$/.test(t)) return NaN;
    return Number(t.replace(',', '.'));
  }

  function imBereich(name, x) {
    var n = zahl(x);
    var g = GRENZEN[name];
    return isFinite(n) && n >= g[0] && n <= g[1] ? n : NaN;
  }

  function runde2(x) {
    return Math.round(x * 100) / 100;
  }

  function istLaufzeit(n) {
    return LAUFZEITEN.indexOf(n) !== -1;
  }

  // F-3a: Familie aus dem Geraetenamen (Standardgeraet der Settings): X10 Dual Screen oder sonst SandenVendo
  function familieAusName(name) {
    return /(?:^|[^a-z0-9])x10(?![a-z0-9])/i.test(String(name || '')) ? 'x10' : 'sandenvendo';
  }

  // Wege je Familie: X10 Kauf, Leasing, Mietkauf, Miete; alles andere (auch unbekannt) nur Kauf und Leasing
  function wegeFuer(familie) {
    return (familie === 'x10' ? WEGE.x10 : WEGE.sandenvendo).slice();
  }

  // Wege in fester Reihenfolge (VARIANTEN); ohne gueltige Angabe alle vier (Rechenkern, Tests)
  function gueltigeWege(wege) {
    var w = Array.isArray(wege) ? VARIANTEN.filter(function (v) { return wege.indexOf(v) !== -1; }) : [];
    return w.indexOf('kauf') !== -1 && w.indexOf('leasing') !== -1 ? w : VARIANTEN.slice();
  }

  // F-4: Tischgeraet? Kennzeichen tisch (true/false) zuerst, dann Tags bauform:standgeraet/bauform:tischgeraet, dann die
  // Regel aus snippets/mv-bauform.liquid (Produkttyp Tischautomat, Typ oder Tag typ:tisch, Tag familie:uno), zuletzt Handle
  // oder Name einer Tischgeraete-Baureihe (TISCHGERAETE). Alles andere (auch ohne Angabe) ist ein Standautomat.
  function istTischgeraet(g) {
    var x = typeof g === 'string' ? { name: g } : g;
    if (!istObjekt(x)) return false;
    if (x.tisch === true || x.tisch === false) return x.tisch;
    var tags = (Array.isArray(x.tags) ? x.tags : []).map(function (t) { return String(t).trim().toLowerCase(); });
    if (tags.indexOf('bauform:standgeraet') !== -1) return false;
    if (tags.indexOf('bauform:tischgeraet') !== -1 || tags.indexOf('typ:tisch') !== -1 || tags.indexOf('familie:uno') !== -1) return true;
    if (String(x.type || '').trim() === 'Tischautomat' || String(x.typ || '').trim().toLowerCase() === 'tisch') return true;
    if (TISCHGERAETE.handles.indexOf(String(x.handle || '').trim().toLowerCase()) !== -1) return true;
    return TISCH_NAME.test(String(x.title || x.name || ''));
  }

  // F-5 (03.11.2026): keine Mindestrate der Partnerbank - fuer jedes Geraet 0 (Signatur und Export bleiben; bis F-5:
  // Standautomaten LEASING_MINDESTRATE, Tischgeraete 0)
  function mindestrateFuer(g) {
    return 0;
  }

  // F-5 (03.11.2026): Leasingrate je Monat = Betrag (netto, nach Anzahlung) x Faktor in %, ohne Untergrenze; mindestrate
  // wird nicht mehr ausgewertet (Signatur bleibt). roh und rate sind gleich, angehoben und ohneMindestrate immer false
  function leasingRate(betrag, faktorProzent, mindestrate) {
    var roh = (betrag * faktorProzent) / 100;
    return { roh: roh, rate: roh, mindestrate: 0, angehoben: false, ohneMindestrate: false };
  }

  // Leasingfaktor einer Laufzeit aus dem Rahmen der Partnerbank (Doku f3-finanzierung Abschnitt 2): Monatszins i so, dass
  // der Rahmenfaktor bei Rahmenlaufzeit und Restwert aufgeht (Raten nachschuessig, Restwert am Ende), dann derselbe
  // Zins fuer n Monate; Prozent auf drei Nachkommastellen. Die Standardwerte (STANDARD, Schema) sind so gerechnet.
  function abgeleiteterFaktor(n, rahmen) {
    var r = rahmen || RAHMEN;
    var rw = r.restwert / 100;
    var faktor = function (i, m) {
      return ((1 - rw * Math.pow(1 + i, -m)) * i) / (1 - Math.pow(1 + i, -m)) * 100;
    };
    if (n === r.laufzeit) return r.faktor;
    var lo = 1e-7;
    var hi = 0.05;
    for (var k = 0; k < 200; k++) {
      var mitte = (lo + hi) / 2;
      if (faktor(mitte, r.laufzeit) > r.faktor) hi = mitte;
      else lo = mitte;
    }
    return Math.round(faktor((lo + hi) / 2, n) * 1000) / 1000;
  }

  function wertOder(name, x, ersatz) {
    var n = x === null || x === undefined ? NaN : imBereich(name, x);
    return isFinite(n) ? n : ersatz;
  }

  // Standardwerte aus dem Datenblock der Sektion (Settings); ungueltige Werte -> STANDARD
  function basisAus(daten) {
    var d = istObjekt(daten) ? daten : {};
    var std = istObjekt(d.standard) ? d.standard : {};
    var an = istObjekt(d.annahmen) ? d.annahmen : {};
    var lf = istObjekt(an.leasingFaktor) ? an.leasingFaktor : {};
    var lz = zahl(an.laufzeit);
    var name = typeof std.name === 'string' && std.name.trim() ? std.name.trim() : STANDARD.geraetName;
    var b = {
      geraetName: name,
      // F-3a: Familie des Standardgeraets (Datenblock, sonst aus dem Namen)
      familie: std.familie === 'x10' || std.familie === 'sandenvendo' ? std.familie : familieAusName(name),
      // F-4: Standardgeraet ein Tischgeraet? (Datenblock tisch, sonst aus dem Namen)
      tisch: typeof std.tisch === 'boolean' ? std.tisch : istTischgeraet(name),
      preis: wertOder('preis', std.preis, STANDARD.preis),
      laufzeit: istLaufzeit(lz) ? lz : STANDARD.laufzeit,
      anzahlung: wertOder('anzahlung', an.anzahlung, STANDARD.anzahlung),
      leasingFaktor: {},
      restwert: wertOder('restwert', an.restwert, STANDARD.restwert),
      mietkaufZins: wertOder('mietkaufZins', an.mietkaufZins, STANDARD.mietkaufZins),
      mieteFaktor: wertOder('mieteFaktor', an.mieteFaktor, STANDARD.mieteFaktor),
      steuersatz: wertOder('steuersatz', an.steuersatz, STANDARD.steuersatz),
      nutzungsdauer: wertOder('nutzungsdauer', an.nutzungsdauer, STANDARD.nutzungsdauer),
      nutzungsdauerGetraenke: wertOder('nutzungsdauer', an.nutzungsdauerGetraenke, STANDARD.nutzungsdauerGetraenke)
    };
    LAUFZEITEN.forEach(function (n) {
      b.leasingFaktor[n] = wertOder('leasingFaktor', lf[n], STANDARD.leasingFaktor[n]);
    });
    return b;
  }

  function startZustand(basis) {
    var b = basis || basisAus(null);
    return { geraet: 'standard', preis: b.preis, laufzeit: b.laufzeit, antworten: {}, eigene: {} };
  }

  // Zustand pruefen: nur erlaubte Werte, Zahlen auf zwei Stellen; Unbekanntes faellt still weg
  function normalisiereZustand(z, basis) {
    var b = basis || basisAus(null);
    var s = istObjekt(z) ? z : {};
    var out = startZustand(b);
    if (s.geraet === 'standard' || s.geraet === 'eigen' || (typeof s.geraet === 'string' && /^\d{1,20}$/.test(s.geraet))) out.geraet = s.geraet;
    var p = imBereich('preis', s.preis);
    if (isFinite(p)) out.preis = runde2(p);
    var n = zahl(s.laufzeit);
    if (istLaufzeit(n)) out.laufzeit = n;
    var a = istObjekt(s.antworten) ? s.antworten : {};
    FRAGEN.forEach(function (f) {
      if (a[f] === 'ja' || a[f] === 'nein') out.antworten[f] = a[f];
    });
    var e = istObjekt(s.eigene) ? s.eigene : {};
    ANNAHMEN.forEach(function (k) {
      if (!hat(e, k)) return;
      if (k === 'leasingFaktor') {
        var lf = istObjekt(e.leasingFaktor) ? e.leasingFaktor : {};
        var o = {};
        var gefunden = false;
        LAUFZEITEN.forEach(function (lz) {
          var w = hat(lf, lz) ? imBereich('leasingFaktor', lf[lz]) : NaN;
          if (isFinite(w)) {
            o[lz] = runde2(w);
            gefunden = true;
          }
        });
        if (gefunden) out.eigene.leasingFaktor = o;
        return;
      }
      var w = imBereich(k, e[k]);
      if (isFinite(w)) out.eigene[k] = runde2(w);
    });
    return out;
  }

  // Nutzungsdauer laut AfA-Tabelle: Getraenkeautomaten (7.4.1) sieben, sonst Warenautomaten (7.4.2) fuenf Jahre
  function nutzungsdauerFuer(typ, basis) {
    var b = basis || basisAus(null);
    return typ === 'getraenke' ? b.nutzungsdauerGetraenke : b.nutzungsdauer;
  }

  // Wirksame Annahmen fuer die gewaehlte Laufzeit: eigene Werte vor Settings vor STANDARD
  function annahmenFuer(z, basis, typ) {
    var b = basis || basisAus(null);
    var s = normalisiereZustand(z, b);
    var e = s.eigene;
    var n = s.laufzeit;
    var nimm = function (k) {
      return hat(e, k) ? e[k] : b[k];
    };
    return {
      preis: s.preis,
      laufzeit: n,
      anzahlung: nimm('anzahlung'),
      leasingFaktor: e.leasingFaktor && hat(e.leasingFaktor, n) ? e.leasingFaktor[n] : b.leasingFaktor[n],
      restwert: nimm('restwert'),
      mietkaufZins: nimm('mietkaufZins'),
      mieteFaktor: nimm('mieteFaktor'),
      steuersatz: nimm('steuersatz'),
      nutzungsdauer: hat(e, 'nutzungsdauer') ? e.nutzungsdauer : nutzungsdauerFuer(typ, b)
    };
  }

  function gueltig(a, k) {
    var x = a[k];
    return typeof x === 'number' && isFinite(x) && x >= GRENZEN[k][0] && x <= GRENZEN[k][1];
  }

  // Rechenkern (Formeln: _docs/wf-finvergleich.md Abschnitt 3); ungueltige Annahmen -> null. wege (F-3a): Wege des
  // Geraets fuer Rangfolge, Summen, Kurve und Texte; gerechnet werden immer alle vier. mindestrate (F-4): seit F-5
  // (03.11.2026) ohne Wirkung - keine Mindestrate, die Leasingrate ist Betrag x Faktor (Parameter bleibt)
  function rechne(a, wege, mindestrate) {
    if (!istObjekt(a)) return null;
    var n = a.laufzeit;
    if (typeof n !== 'number' || !isFinite(n) || n < 1 || n > 120 || Math.floor(n) !== n) return null;
    var namen = ['preis', 'anzahlung', 'leasingFaktor', 'restwert', 'mietkaufZins', 'mieteFaktor', 'steuersatz', 'nutzungsdauer'];
    for (var i = 0; i < namen.length; i++) {
      if (!gueltig(a, namen[i])) return null;
    }
    var P = a.preis;
    var A = (P * a.anzahlung) / 100;
    var rest = P - A;
    var s = a.steuersatz / 100;
    var ndMonate = a.nutzungsdauer * 12;
    var afaMonat = P / ndMonate;
    var afa = Math.min(P, afaMonat * Math.min(n, ndMonate));
    var restbuchwert = Math.max(0, P - afa);

    function weg(id, start, rate, eigentum) {
      var gesamt = start + rate * n;
      return {
        id: id,
        monatlich: rate,
        start: start,
        anstieg: rate,
        gesamt: gesamt,
        ersterMonat: start + rate,
        mehr: gesamt - P,
        mehrProzent: P > 0 ? ((gesamt - P) / P) * 100 : null,
        eigentum: eigentum,
        gleichstand: null
      };
    }

    function gleichstand(w) {
      if (w.start >= P - 1e-9) return 0;
      if (!(w.anstieg > 0)) return null;
      var m = Math.ceil((P - w.start) / w.anstieg - 1e-9);
      return m <= n ? m : null;
    }

    function steuerlich(w, betriebsausgaben) {
      w.betriebsausgaben = betriebsausgaben;
      w.steuer = betriebsausgaben * s;
      w.nachSteuern = w.gesamt - w.steuer;
      return w;
    }

    var kauf = steuerlich(weg('kauf', P, 0, true), afa);
    kauf.afaMonat = afaMonat;
    kauf.afa = afa;
    kauf.restbuchwert = restbuchwert;
    kauf.ersterMonat = P;

    // Rate aus den Annahmen (F-5: ohne Mindestrate, leasingRate hebt nie an)
    var lr = leasingRate(rest, a.leasingFaktor, mindestrate);
    var leasing = weg('leasing', A, lr.rate, false);
    leasing.rateRoh = lr.roh;
    steuerlich(leasing, leasing.gesamt);
    leasing.uebernahme = (P * a.restwert) / 100;
    var verhaeltnis = n / ndMonate;
    leasing.hinweis = verhaeltnis > LEASING_RAHMEN[1] ? 'lang' : verhaeltnis < LEASING_RAHMEN[0] ? 'kurz' : null;
    leasing.gleichstand = gleichstand(leasing);

    var zinsMonat = Math.pow(1 + a.mietkaufZins / 100, 1 / 12) - 1;
    var rateMk = zinsMonat > 0 ? (rest * zinsMonat) / (1 - Math.pow(1 + zinsMonat, -n)) : rest / n;
    var mietkauf = weg('mietkauf', A, rateMk, true);
    mietkauf.zinsen = Math.max(0, rateMk * n - rest);
    mietkauf.afa = afa;
    mietkauf.restbuchwert = restbuchwert;
    steuerlich(mietkauf, afa + mietkauf.zinsen);
    mietkauf.gleichstand = gleichstand(mietkauf);

    var miete = weg('miete', 0, (P * a.mieteFaktor) / 100, false);
    steuerlich(miete, miete.gesamt);
    miete.gleichstand = gleichstand(miete);

    var e = { preis: P, laufzeit: n, annahmen: a, kauf: kauf, leasing: leasing, mietkauf: mietkauf, miete: miete, wege: gueltigeWege(wege) };
    var nachFeld = function (feld) {
      return e.wege.slice().sort(function (x, y) {
        var d = e[x][feld] - e[y][feld];
        return Math.abs(d) > 1e-9 ? d : VARIANTEN.indexOf(x) - VARIANTEN.indexOf(y);
      });
    };
    e.reihenfolge = nachFeld('gesamt');
    e.guenstigste = e.reihenfolge[0];
    e.guenstigsteNachSteuern = nachFeld('nachSteuern')[0];
    return e;
  }

  // Wege eines Ergebnisses (F-3a); aeltere Ergebnisse ohne Angabe: alle vier
  function wegeVon(e) {
    return e && Array.isArray(e.wege) ? e.wege : VARIANTEN;
  }

  // Kumulierte Kosten je Monat 0..Laufzeit (linear: Startwert + Rate x Monat, also nie fallend); nur die Wege des Geraets
  function kurve(e) {
    var out = { monate: [], reihen: {} };
    if (!e) return out;
    var wege = wegeVon(e);
    wege.forEach(function (v) {
      out.reihen[v] = [];
    });
    for (var m = 0; m <= e.laufzeit; m++) {
      out.monate.push(m);
      for (var i = 0; i < wege.length; i++) {
        var w = e[wege[i]];
        out.reihen[wege[i]].push(w.start + w.anstieg * m);
      }
    }
    return out;
  }

  // Runde Achsenmarken ab 0: Schritt 1, 2, 2,5 oder 5 mal Zehnerpotenz, etwa vier Abschnitte
  function achse(max) {
    var m = typeof max === 'number' && isFinite(max) && max > 0 ? max : 1;
    var roh = m / 4;
    var p = Math.pow(10, Math.floor(Math.log(roh) / Math.LN10 + 1e-12));
    var stufen = [1, 2, 2.5, 5, 10];
    var schritt = 10 * p;
    for (var i = 0; i < stufen.length; i++) {
      if (stufen[i] * p >= roh - 1e-12) {
        schritt = stufen[i] * p;
        break;
      }
    }
    var anzahl = Math.max(2, Math.ceil(m / schritt - 1e-9));
    var ticks = [];
    for (var k = 0; k <= anzahl; k++) ticks.push(k * schritt);
    return { max: anzahl * schritt, schritt: schritt, ticks: ticks };
  }

  // D-W2: Breite eines Textes der Kurve in px als obere Schranke fuer Barlow (normal und fett, Ziffern auch mit
  // tabular-nums), ohne Messung im DOM. Zeichenklassen in em: schmal (Leerzeichen, Satzzeichen, i, j, l, r, t, f, I)
  // 0,40; M, W, m, w, % 0,88; Versalien und Eurozeichen 0,68; Ziffern, Kleinbuchstaben und alles uebrige 0,61.
  var BREITE_SCHMAL = ' .,:;!()ijlrtfI' + TEXTE.nbsp;
  var BREITE_WEIT = 'MWmw%';

  function textBreite(text, fs) {
    var s = text === null || text === undefined ? '' : String(text);
    var em = 0;
    for (var i = 0; i < s.length; i++) {
      var c = s.charAt(i);
      if (BREITE_SCHMAL.indexOf(c) !== -1) em += 0.4;
      else if (BREITE_WEIT.indexOf(c) !== -1) em += 0.88;
      else if (c === TEXTE.euro || c !== c.toLowerCase()) em += 0.68;
      else em += 0.61;
    }
    return em * (typeof fs === 'number' && fs > 0 ? fs : 14);
  }

  // D-W2: Masse der Kurve aus der Breite der Flaeche, der Schriftgroesse fs und den Texten an der Achse (Euro-Werte)
  // und an den Enden (Endmarken). Unter 520 px (schmal) stehen die Achsenwerte in der Flaeche ueber ihrer Gitterlinie
  // auf einer Grundflaeche, sonst links daneben; die Endmarken rechts der Flaeche. Rueckgabe: rand {l, r, o, u},
  // Zeichenflaeche pw x ph (ph fest 192 bzw. 248 px), hoehe, Versatz der Grundlinie zur Mitte (mitte), Hoehe der
  // Grundflaeche (grund), Grundlinien der Monate (xAchse) und des Titels (titel) unter der Zeichenflaeche, Mindestabstand
  // der Endmarken (abstand).
  function kurvenMasse(breite, fs, achsenTexte, markenTexte) {
    var b = typeof breite === 'number' && breite >= 260 ? breite : 640;
    var f = typeof fs === 'number' && fs >= 10 ? fs : 14;
    var schmal = b < 520;
    var breitester = function (liste) {
      var m = 0;
      (liste || []).forEach(function (t) {
        m = Math.max(m, textBreite(t, f));
      });
      return m;
    };
    var grund = Math.ceil(f * 0.9);
    var xAchse = Math.round(f * 1.5);
    var titel = xAchse + Math.round(f * 1.35);
    var rand = {
      l: schmal ? 6 : Math.ceil(breitester(achsenTexte)) + 12,
      r: Math.ceil(breitester(markenTexte)) + 20,
      o: schmal ? grund + 10 : 16,
      u: titel + Math.max(2, Math.ceil(f * 0.25))
    };
    var ph = schmal ? 192 : 248;
    return {
      schmal: schmal,
      fs: f,
      breite: b,
      rand: rand,
      pw: b - rand.l - rand.r,
      ph: ph,
      hoehe: rand.o + ph + rand.u,
      mitte: Math.round(f * 0.35),
      grund: grund,
      xAchse: xAchse,
      titel: titel,
      abstand: Math.max(16, Math.ceil(f * 4 / 3))
    };
  }

  // K-A: Lage der Achsenwerte in der Flaeche (mobil, masse.schmal). Alle Werte stehen am linken Rand auf derselben
  // Seite ihrer Gitterlinie: darueber (Grundlinie 5 px ueber der Linie) oder darunter (Oberkante der Ziffern 5 px
  // darunter), damit jeder Wert eindeutig zu seiner Linie gehoert. Gewaehlt wird die Seite, auf der insgesamt weniger
  // Kurve mitten durch die Ziffern laeuft (Ueberdeckung = waagrechte Laenge der Linien im Kern der Ziffern, 0,1 bis
  // 0,62 em ueber der Grundlinie, halber Strich 1 px zugegeben, Breite textBreite; eine Linie, die nur Ober- oder
  // Unterkante streift, laesst die Ziffern lesbar); bei Gleichstand darueber. Die Linien liegen im SVG ueber den Werten
  // (kurveZeichnen), sie werden nie verdeckt. Rueckgabe je Wert > 0: { wert, unten, grundlinie, ueberdeckung }.
  var ZIFFERN_EM = 0.72;
  var KERN_EM = [0.1, 0.62];
  // Abstand der Ziffern zur Gitterlinie (D-W2: 6 px; 5 px lassen der Kauf-Linie im Beispiel 5.900 EUR Luft ueber "5.000 EUR")
  var ABSTAND_WERT = 5;

  function achsenLage(e, masse, ax) {
    var n = e && e.laufzeit > 0 ? e.laufzeit : 0;
    var rand = masse.rand;
    var fs = masse.fs;
    var ziffern = Math.ceil(fs * ZIFFERN_EM);
    var x = function (m) { return rand.l + (n > 0 ? (m / n) * masse.pw : 0); };
    var y = function (w) { return rand.o + masse.ph - (ax.max > 0 ? (w / ax.max) * masse.ph : 0); };
    var ueber = function (x0, x1, y0, y1) {
      var summe = 0;
      wegeVon(e).forEach(function (v) {
        var w = e[v];
        var ya = y(w.start);
        var yb = y(w.start + w.anstieg * n);
        var lo = y0 - 1;
        var hi = y1 + 1;
        var ma = 0;
        var mb = n;
        if (Math.abs(yb - ya) < 1e-9) {
          if (ya < lo || ya > hi) return;
        } else {
          var t1 = (lo - ya) / (yb - ya) * n;
          var t2 = (hi - ya) / (yb - ya) * n;
          ma = Math.max(0, Math.min(t1, t2));
          mb = Math.min(n, Math.max(t1, t2));
          if (!(mb > ma)) return;
        }
        var xa = Math.max(x0, x(ma));
        var xb = Math.min(x1, x(mb));
        if (xb > xa) summe += xb - xa;
      });
      return summe;
    };
    var werte = ax.ticks.filter(function (t) { return t > 0; });
    var seite = function (unten) {
      return werte.map(function (t) {
        var yg = y(t);
        var grundlinie = unten ? r1(yg + ABSTAND_WERT + ziffern) : r1(yg - ABSTAND_WERT);
        var x0 = rand.l + 1;
        return { wert: t, unten: unten, grundlinie: grundlinie, ueberdeckung: r1(ueber(x0, x0 + textBreite(euro0(t), fs), grundlinie - KERN_EM[1] * fs, grundlinie - KERN_EM[0] * fs)) };
      });
    };
    var summe = function (liste) { return liste.reduce(function (s2, l) { return s2 + l.ueberdeckung; }, 0); };
    var oben = seite(false);
    var unten = seite(true);
    return summe(unten) < summe(oben) ? unten : oben;
  }

  // Entscheidungshilfe: alle drei Fragen beantwortet -> genau ein Weg mit Alternative, sonst null. wege (F-3a): beim X10
  // die Tabelle EMPFEHLUNGEN (Kauf oder Leasing, Alternative auch Mietkauf oder Miete), sonst Kauf und Leasing mit dem
  // jeweils anderen als Alternative; ohne Angabe alle vier Wege
  function empfehlung(antworten, wege) {
    if (!istObjekt(antworten)) return null;
    var k = '';
    for (var i = 0; i < FRAGEN.length; i++) {
      var w = antworten[FRAGEN[i]];
      if (w === 'ja') k += 'j';
      else if (w === 'nein') k += 'n';
      else return null;
    }
    var e = EMPFEHLUNGEN[k];
    var g = gueltigeWege(wege);
    var alternative = g.indexOf(e[1]) !== -1 ? e[1] : e[0] === 'kauf' ? 'leasing' : 'kauf';
    return { schluessel: k, variante: e[0], alternative: alternative };
  }

  function gross(t) {
    return t.charAt(0).toUpperCase() + t.slice(1);
  }

  function summenText(e) {
    return wegeVon(e).map(function (v) {
      return NAMEN[v] + ' ' + euro0(e[v].gesamt);
    }).join(', ');
  }

  // Name eines Wegs als Alternative: Mietkauf und Miete mit "(auf Anfrage)" (nur X10, nachrangig)
  function alternativName(v) {
    return NAMEN[v] + (NUR_X10.indexOf(v) !== -1 ? TEXTE.aufAnfrage : '');
  }

  function empfehlungsTexte(emp, e) {
    if (!emp || !hat(TEXTE.empfehlung, emp.schluessel)) return { titel: '', grund: '', zahlen: '', alternative: '' };
    var t = TEXTE.empfehlung[emp.schluessel];
    var zahlen = '';
    if (e) {
      zahlen = TEXTE.gesamtkostenIn + ' ' + e.laufzeit + ' ' + TEXTE.monaten + ' ' + TEXTE.beiIhrenAnnahmen + ' ' + summenText(e) + '.';
      if (e.guenstigste === emp.variante) zahlen += ' ' + gross(ARTIKEL[emp.variante]) + ' ' + TEXTE.auchGeringste;
      else zahlen += ' ' + TEXTE.geringsteVor + ' ' + ARTIKEL[e.guenstigste] + TEXTE.geringsteNach;
    }
    var grund = hat(t.alternativen, emp.alternative) ? t.alternativen[emp.alternative] : '';
    return {
      titel: NAMEN[emp.variante],
      grund: t.grund,
      zahlen: zahlen,
      alternative: grund ? TEXTE.alternative + ' ' + alternativName(emp.alternative) + ' \u2013 ' + grund : ''
    };
  }

  function interesseFuer(variante) {
    return hat(INTERESSE, variante) ? INTERESSE[variante] : INTERESSE_OHNE;
  }

  // ------------------------------------------------------------------ Geraete aus dem Datenblock

  function produktName(title, x10) {
    if (x10) return 'X10 Dual Screen';
    return String(title || '')
      .replace(/^SandenVendo\s+/, '')
      .replace(/\s*\([^)]*\)\s*$/, '')
      .replace(/\s+[\u2013\u2014-]\s+.*$/, '')
      .trim();
  }

  // Varianten eines Produkts: gleiche Preise -> eine Option; sonst Name plus die Optionswerte, die sich unterscheiden
  function optionenFuer(g, typ) {
    var name = produktName(g.title, g.x10);
    var vs = (Array.isArray(g.varianten) ? g.varianten : []).filter(function (v) {
      return v && /^\d{1,20}$/.test(String(v.id)) && typeof v.preis === 'number' && v.preis > 0;
    });
    if (!vs.length || !name) return [];
    // F-3a: Familie aus dem Datenblock, aeltere Datenbloecke ohne Feld ueber x10
    var familie = g.familie === 'x10' || g.familie === 'sandenvendo' ? g.familie : g.x10 ? 'x10' : 'sandenvendo';
    // F-4: Tischgeraet aus Kennzeichen, Tags, Typ, Handle oder Titel des Datenblocks (seit F-5 ohne Wirkung auf die Rate)
    var tisch = !g.x10 && istTischgeraet(g);
    var preise = {};
    vs.forEach(function (v) {
      preise[v.preis] = true;
    });
    if (Object.keys(preise).length === 1) return [{ wert: String(vs[0].id), name: name, preis: vs[0].preis / 100, typ: typ, familie: familie, tisch: tisch }];
    var teile = vs.map(function (v) {
      return typeof v.titel === 'string' && v.titel !== 'Default Title' ? v.titel.split(' / ').map(function (t) { return t.trim(); }) : [];
    });
    var laenge = 0;
    teile.forEach(function (t) {
      laenge = Math.max(laenge, t.length);
    });
    var konstant = [];
    for (var k = 0; k < laenge; k++) {
      konstant[k] = teile.every(function (t) { return t[k] === teile[0][k]; });
    }
    var namensTeile = name.split(' / ').map(function (t) { return t.trim(); });
    var out = [];
    var gesehen = {};
    vs.forEach(function (v, i) {
      var rest = teile[i].filter(function (t, j) { return t && !konstant[j]; });
      var label = rest.length === 1 && namensTeile.indexOf(rest[0]) !== -1 ? rest[0] : rest.length ? name + ' ' + rest.join(' ') : name;
      var schluessel = label + '|' + v.preis;
      if (gesehen[schluessel]) return;
      gesehen[schluessel] = true;
      out.push({ wert: String(v.id), name: label, preis: v.preis / 100, typ: typ, familie: familie, tisch: tisch });
    });
    return out;
  }

  function geraeteOptionen(daten) {
    var liste = istObjekt(daten) && Array.isArray(daten.geraete) ? daten.geraete : [];
    var titel = {};
    GRUPPEN.forEach(function (g) {
      titel[g[0]] = g[1];
    });
    var je = {};
    liste.forEach(function (g) {
      if (!istObjekt(g)) return;
      var typ = typeof g.typ === 'string' && g.typ ? g.typ : g.x10 ? 'snack' : '';
      var gruppe = g.x10 ? 'x10' : hat(titel, typ) && typ !== 'x10' && typ !== 'sonst' ? typ : 'sonst';
      var opts = optionenFuer(g, g.x10 ? 'snack' : typ);
      if (!opts.length) return;
      je[gruppe] = (je[gruppe] || []).concat(opts);
    });
    return GRUPPEN.filter(function (g) {
      return hat(je, g[0]);
    }).map(function (g) {
      return { gruppe: g[0], titel: g[1], optionen: je[g[0]] };
    });
  }

  // ------------------------------------------------------------------ Zustand im Hash

  function zahlKurz(x) {
    return String(runde2(x));
  }

  // F-3a: Leasingfaktor mit bis zu drei Nachkommastellen (abgeleitete Faktoren wie 1,935 %), sonst wie zahlKurz
  function zahlFaktor(x) {
    return String(Math.round(x * 1000) / 1000);
  }

  function zahlPunkt(t) {
    return typeof t === 'string' && /^\d{1,9}(?:\.\d{1,6})?$/.test(t) ? Number(t) : NaN;
  }

  // #fv=1:<geraet>,<preis>,<laufzeit>,<antworten>[;<kuerzel>=<wert>,...]; geraet s (Standard), e (eigen) oder Varianten-ID
  function kodiere(z, basis) {
    var b = basis || basisAus(null);
    var s = normalisiereZustand(z, b);
    var g = s.geraet === 'standard' ? 's' : s.geraet === 'eigen' ? 'e' : s.geraet;
    var ant = FRAGEN.map(function (f) {
      return s.antworten[f] === 'ja' ? 'j' : s.antworten[f] === 'nein' ? 'n' : '-';
    }).join('');
    var extra = [];
    ANNAHMEN.forEach(function (k) {
      if (!hat(s.eigene, k)) return;
      if (k === 'leasingFaktor') {
        LAUFZEITEN.forEach(function (n) {
          if (hat(s.eigene.leasingFaktor, n)) extra.push('l' + n + '=' + zahlFaktor(s.eigene.leasingFaktor[n]));
        });
        return;
      }
      extra.push(HASH_CODES[k] + '=' + zahlKurz(s.eigene[k]));
    });
    return HASH_PRAEFIX + [g, zahlKurz(s.preis), s.laufzeit, ant].join(',') + (extra.length ? ';' + extra.join(',') : '');
  }

  function dekodiere(text, basis) {
    var b = basis || basisAus(null);
    var t = String(text === null || text === undefined ? '' : text).replace(/^#/, '');
    if (t.indexOf(HASH_PRAEFIX) !== 0) return null;
    var teile = t.slice(HASH_PRAEFIX.length).split(';');
    var kopf = (teile[0] || '').split(',');
    var z = { antworten: {}, eigene: {} };
    if (kopf[0] === 's') z.geraet = 'standard';
    else if (kopf[0] === 'e') z.geraet = 'eigen';
    else if (/^\d{1,20}$/.test(kopf[0] || '')) z.geraet = kopf[0];
    var p = zahlPunkt(kopf[1]);
    if (isFinite(p)) z.preis = p;
    var n = zahlPunkt(kopf[2]);
    if (isFinite(n)) z.laufzeit = n;
    var ant = kopf[3] || '';
    FRAGEN.forEach(function (f, i) {
      var c = ant.charAt(i);
      if (c === 'j') z.antworten[f] = 'ja';
      else if (c === 'n') z.antworten[f] = 'nein';
    });
    (teile[1] || '').split(',').forEach(function (paar) {
      var kv = paar.split('=');
      if (kv.length !== 2) return;
      var w = zahlPunkt(kv[1]);
      if (!isFinite(w)) return;
      var lz = /^l(36|48|54|60)$/.exec(kv[0]);
      if (lz) {
        z.eigene.leasingFaktor = z.eigene.leasingFaktor || {};
        z.eigene.leasingFaktor[lz[1]] = w;
        return;
      }
      for (var k in HASH_CODES) {
        if (hat(HASH_CODES, k) && HASH_CODES[k] === kv[0]) z.eigene[k] = w;
      }
    });
    return normalisiereZustand(z, b);
  }

  // ------------------------------------------------------------------ Formatierung (de-DE)

  function tausender(t) {
    return t.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  // Tausenderpunkt, Dezimalkomma, echtes Minus; stellen = feste Nachkommastellen, sonst hoechstens zwei
  function zahlText(n, stellen) {
    if (typeof n !== 'number' || !isFinite(n)) return TEXTE.strich;
    var fest = typeof stellen === 'number' && stellen >= 0;
    var faktor = Math.pow(10, fest ? stellen : 2);
    var r = Math.round((Math.abs(n) + 1e-9) * faktor) / faktor;
    var teile = (fest ? r.toFixed(stellen) : String(r)).split('.');
    var text = tausender(teile[0]) + (teile[1] ? ',' + teile[1] : '');
    return n < 0 && r !== 0 ? TEXTE.minus + text : text;
  }

  function euro0(x) {
    if (typeof x !== 'number' || !isFinite(x)) return TEXTE.strich;
    return zahlText(Math.round(x)) + TEXTE.nbsp + TEXTE.euro;
  }

  function euro2(x) {
    if (typeof x !== 'number' || !isFinite(x)) return TEXTE.strich;
    return zahlText(x, 2) + TEXTE.nbsp + TEXTE.euro;
  }

  // Geraetepreis: ganze Euro ohne Nachkommastellen, sonst mit Cent
  function euroPreis(x) {
    return typeof x === 'number' && Math.abs(x - Math.round(x)) < 0.005 ? euro0(x) : euro2(x);
  }

  function prozentText(x) {
    if (typeof x !== 'number' || !isFinite(x)) return TEXTE.strich;
    return zahlText(x) + TEXTE.nbsp + '%';
  }

  // F-3a: Leasingfaktor wie gerechnet, mit bis zu drei Nachkommastellen (2,09 %, 2,871 %, 1,935 %)
  function faktorText(x) {
    if (typeof x !== 'number' || !isFinite(x)) return TEXTE.strich;
    var teile = String(Math.round((Math.abs(x) + 1e-9) * 1000) / 1000).split('.');
    return tausender(teile[0]) + (teile[1] ? ',' + teile[1] : '') + TEXTE.nbsp + '%';
  }

  function monateText(n) {
    return n === 1 ? '1 ' + TEXTE.monat : n + ' ' + TEXTE.monaten;
  }

  function jahreText(n) {
    return n === 1 ? '1 ' + TEXTE.jahr : zahlText(n) + ' ' + TEXTE.jahre;
  }

  function ca(text) {
    return TEXTE.ca + TEXTE.nbsp + text;
  }

  function mitVorzeichen(x, text) {
    return x > 0 ? '+' + text : text;
  }

  // ------------------------------------------------------------------ Texte

  function leereWerte(v) {
    return {
      monatlich: TEXTE.strich,
      gesamt: TEXTE.strich,
      mehr: v === 'kauf' ? '' : TEXTE.strich,
      liquiditaet: TEXTE.strich,
      gleichstand: v === 'kauf' ? '' : TEXTE.strich,
      eigentum: v === 'kauf' ? TEXTE.eigentum.kauf : v === 'mietkauf' ? TEXTE.eigentum.mietkauf : v === 'miete' ? TEXTE.eigentum.miete : TEXTE.eigentum.leasingVor + TEXTE.eigentum.leasingNach,
      steuer: TEXTE.strich,
      nachsteuern: TEXTE.strich,
      hinweis: ''
    };
  }

  function eigentumText(v, w) {
    if (v === 'kauf') return TEXTE.eigentum.kauf;
    if (v === 'mietkauf') return TEXTE.eigentum.mietkauf;
    if (v === 'miete') return TEXTE.eigentum.miete;
    return TEXTE.eigentum.leasingVor + ' ' + ca(euro0(w.uebernahme)) + TEXTE.eigentum.leasingNach;
  }

  function hinweisText(v, w) {
    if (v === 'leasing') {
      var teile = [];
      if (w.hinweis === 'lang') teile.push(TEXTE.leasingLang);
      else if (w.hinweis === 'kurz') teile.push(TEXTE.leasingKurz);
      return teile.join(' ');
    }
    if ((v === 'kauf' || v === 'mietkauf') && w.restbuchwert > 0.5) return TEXTE.restbuchwertVor + ' ' + ca(euro0(w.restbuchwert)) + TEXTE.restbuchwertNach;
    return '';
  }

  function mehrText(w) {
    var euro = mitVorzeichen(Math.round(w.mehr), euro0(w.mehr));
    var prozent = w.mehrProzent === null ? TEXTE.strich : mitVorzeichen(Math.round(w.mehrProzent), prozentText(Math.round(w.mehrProzent)));
    return euro + ' (' + prozent + ')';
  }

  function gleichstandText(w) {
    if (w.gleichstand === null) return TEXTE.nichtInLaufzeit;
    if (w.gleichstand === 0) return TEXTE.sofort;
    return TEXTE.nach + ' ' + monateText(w.gleichstand);
  }

  // Texte der vier Karten (Slots data-mv-finv-wert); ohne Ergebnis Striche
  function werteTexte(e) {
    var out = {};
    VARIANTEN.forEach(function (v) {
      if (!e) {
        out[v] = leereWerte(v);
        return;
      }
      var w = e[v];
      out[v] = {
        monatlich: v === 'kauf' ? TEXTE.keineRate : euro2(w.monatlich),
        gesamt: euro0(w.gesamt),
        mehr: v === 'kauf' ? '' : mehrText(w),
        liquiditaet: v === 'kauf' ? euro0(w.ersterMonat) : euro2(w.ersterMonat),
        gleichstand: v === 'kauf' ? '' : gleichstandText(w),
        eigentum: eigentumText(v, w),
        steuer: ca(euro0(w.steuer)),
        nachsteuern: ca(euro0(w.nachSteuern)),
        hinweis: hinweisText(v, w)
      };
    });
    return out;
  }

  // Annahmen-Zeile; wege (F-3a): Zins Mietkauf und Miete nur, wenn das Geraet diese Wege hat (X10)
  function annahmenText(a, wege) {
    if (!a) return '';
    var w = gueltigeWege(wege);
    var teile = [
      TEXTE.geraetepreis + ' ' + euroPreis(a.preis) + ' ' + TEXTE.netto,
      TEXTE.laufzeit + ' ' + a.laufzeit + ' ' + TEXTE.monate,
      TEXTE.anzahlung + ' ' + prozentText(a.anzahlung),
      TEXTE.leasingfaktor + ' ' + faktorText(a.leasingFaktor) + ' ' + TEXTE.jeMonat,
      TEXTE.restwert + ' ' + prozentText(a.restwert)
    ];
    if (w.indexOf('mietkauf') !== -1) teile.push(TEXTE.zinsMietkauf + ' ' + prozentText(a.mietkaufZins) + ' ' + TEXTE.imJahr);
    if (w.indexOf('miete') !== -1) teile.push(TEXTE.miete + ' ' + prozentText(a.mieteFaktor) + ' ' + TEXTE.jeMonat);
    teile.push(TEXTE.steuersatz + ' ' + prozentText(a.steuersatz), TEXTE.abschreibung + ' ' + jahreText(a.nutzungsdauer));
    return TEXTE.annahmenVor + ' ' + teile.join(TEXTE.trenner);
  }

  function zusammenfassung(e) {
    if (!e) return '';
    return TEXTE.gesamtkostenIn + ' ' + e.laufzeit + ' ' + TEXTE.monaten + ', ' + TEXTE.netto + ': ' + summenText(e) + '.';
  }

  function kurvenText(e) {
    if (!e) return TEXTE.kurveLeer;
    return TEXTE.kurveNach + ' ' + e.laufzeit + ' ' + TEXTE.monaten + ', ' + TEXTE.netto + ': ' + summenText(e) + '. ' + TEXTE.kurveVerlauf;
  }

  function monatsLabel(m) {
    return m === 0 ? TEXTE.start : TEXTE.monat + ' ' + m;
  }

  function wertImMonat(e, v, m) {
    var w = e[v];
    return w.start + w.anstieg * m;
  }

  // Zeilen der Tabelle: Start, Monat 1, jedes volle Jahr und das Ende der Laufzeit
  function tabellenZeilen(e) {
    if (!e) return [];
    var monate = TABELLE_MONATE.filter(function (m) { return m <= e.laufzeit; });
    if (monate[monate.length - 1] !== e.laufzeit) monate.push(e.laufzeit);
    return monate.map(function (m) {
      var werte = {};
      wegeVon(e).forEach(function (v) {
        werte[v] = euro0(wertImMonat(e, v, m));
      });
      return { monat: m, label: monatsLabel(m), werte: werte };
    });
  }

  // Ansage fuer Screenreader bei Tastaturbedienung der Kurve: "Monat 12: 5.900 EUR Kauf, ..." (K-2)
  function monatsAnsage(e, monat) {
    var t = tooltipZeilen(e, monat);
    if (!t.titel) return '';
    return t.titel + ': ' + t.zeilen.map(function (z) { return z.wert + ' ' + z.name; }).join(', ') + '.';
  }

  function tooltipZeilen(e, monat) {
    if (!e) return { titel: '', zeilen: [] };
    var m = Math.max(0, Math.min(e.laufzeit, Math.round(monat)));
    return {
      monat: m,
      titel: monatsLabel(m),
      zeilen: wegeVon(e).map(function (v) {
        return { id: v, name: NAMEN[v], wert: euro0(wertImMonat(e, v, m)) };
      })
    };
  }

  function kuerze(t, max) {
    var s = String(t || '');
    return s.length > max ? s.slice(0, max - 1) + '\u2026' : s;
  }

  function annahmenKurz(a, wege) {
    var w = gueltigeWege(wege);
    var teile = [TEXTE.leasingfaktor + ' ' + faktorText(a.leasingFaktor), TEXTE.restwert + ' ' + prozentText(a.restwert)];
    if (w.indexOf('mietkauf') !== -1) teile.push(TEXTE.zinsMietkauf + ' ' + prozentText(a.mietkaufZins));
    if (w.indexOf('miete') !== -1) teile.push(TEXTE.miete + ' ' + prozentText(a.mieteFaktor));
    teile.push(TEXTE.steuersatz + ' ' + prozentText(a.steuersatz), TEXTE.nutzungsdauer + ' ' + jahreText(a.nutzungsdauer));
    return teile.join(', ');
  }

  // Kurzfassung fuer data-konfiguration der Lightbox (Teile mit Mittelpunkt, ohne die Praefixe Paket/Menge/Auf Anfrage);
  // Raten und Annahmen nur fuer die Wege des Geraets (F-3a)
  function kurzfassung(info) {
    var i = istObjekt(info) ? info : {};
    var a = i.annahmen;
    var e = i.ergebnis;
    var wege = wegeVon(e);
    var teile = [TEXTE.kurzTitel];
    if (i.geraetName) teile.push(TEXTE.kurzGeraet + ' ' + kuerze(i.geraetName, 120));
    if (a) {
      teile.push(TEXTE.kurzPreis + ' ' + euroPreis(a.preis) + ' ' + TEXTE.netto);
      teile.push(TEXTE.kurzLaufzeit + ' ' + a.laufzeit + ' ' + TEXTE.monate);
    }
    if (i.empfehlung) teile.push(TEXTE.kurzEmpfehlung + ' ' + NAMEN[i.empfehlung.variante]);
    if (e) {
      wege.filter(function (v) { return v !== 'kauf'; }).forEach(function (v) {
        teile.push(NAMEN[v] + ': ' + ca(euro2(e[v].monatlich)) + ' ' + TEXTE.imMonat);
      });
    }
    if (a) {
      teile.push(TEXTE.kurzAnzahlung + ' ' + prozentText(a.anzahlung));
      teile.push(TEXTE.kurzAnnahmen + ' ' + annahmenKurz(a, wege));
    }
    return kuerze(teile.join(TEXTE.trenner), KURZ_MAX);
  }

  // Nachricht fuer data-nachricht (Vorbelegung contact[body]); hoechstens NACHRICHT_MAX Zeichen
  function nachricht(info) {
    var i = istObjekt(info) ? info : {};
    var a = i.annahmen;
    var e = i.ergebnis;
    var wege = wegeVon(e);
    var z = [TEXTE.nachrichtGruss, '', TEXTE.nachrichtBitte, ''];
    if (i.geraetName && a) z.push(TEXTE.kurzGeraet + ' ' + kuerze(i.geraetName, 200) + ', ' + euroPreis(a.preis) + ' ' + TEXTE.netto);
    if (a) z.push(TEXTE.kurzLaufzeit + ' ' + a.laufzeit + ' ' + TEXTE.monate + TEXTE.trenner + TEXTE.kurzAnzahlung + ' ' + prozentText(a.anzahlung));
    if (i.empfehlung) z.push(TEXTE.nachrichtEmpfehlung + ' ' + NAMEN[i.empfehlung.variante] + ' (' + TEXTE.alternative + ' ' + alternativName(i.empfehlung.alternative) + ')');
    if (e) {
      z.push('', TEXTE.nachrichtVergleich);
      wege.forEach(function (v) {
        var w = e[v];
        z.push(TEXTE.punkt + NAMEN[v] + ': ' + (v === 'kauf' ? euro0(w.gesamt) + ' ' + TEXTE.einmalig : ca(euro2(w.monatlich)) + ' ' + TEXTE.imMonat + ', ' + TEXTE.nachrichtGesamt + ' ' + ca(euro0(w.gesamt))));
      });
    }
    if (a) z.push(TEXTE.kurzAnnahmen + ' ' + annahmenKurz(a, wege));
    if (i.link) z.push('', TEXTE.nachrichtLink + ' ' + kuerze(i.link, 600));
    return kuerze(z.join('\n'), NACHRICHT_MAX);
  }

  // ------------------------------------------------------------------ Kundenkonto (Paket A-2b)

  var KONTO_WERKZEUG = 'finvergleich';
  var TITEL_MAX = 80;

  // Titel fuer "Meine Werkzeuge" (Backend kuerzt auf 80 Zeichen): Leerraum zusammengefasst, sonst mit Auslassung
  function kurzTitel(t) {
    var s = String(t === null || t === undefined ? '' : t).replace(/\s+/g, ' ').trim();
    return s.length > TITEL_MAX ? s.slice(0, TITEL_MAX - 1).replace(/\s+$/, '') + '\u2026' : s;
  }

  // Stand { v: 1, code, titel }: code wie im Hash (kodiere), titel = Geraet und Laufzeit
  function kontoStand(z, basis, geraetName) {
    var b = basis || basisAus(null);
    var s = normalisiereZustand(z, b);
    var stand = { v: 1, code: kodiere(s, b) };
    var name = kurzTitel(geraetName);
    var titel = kurzTitel((name ? name + ' \u00b7 ' : '') + s.laufzeit + ' ' + TEXTE.monate);
    if (titel) stand.titel = titel;
    return stand;
  }

  // Stand aus Konto oder Spiegel -> Zustand (wie dekodiere aus dem Hash), sonst null
  function kontoStandPruefen(stand, basis) {
    if (!istObjekt(stand) || stand.v !== 1 || typeof stand.code !== 'string') return null;
    return dekodiere(stand.code, basis);
  }

  var api = {
    VERSION: VERSION,
    KONTO_WERKZEUG: KONTO_WERKZEUG,
    kontoStand: kontoStand,
    kontoStandPruefen: kontoStandPruefen,
    LAUFZEITEN: LAUFZEITEN,
    VARIANTEN: VARIANTEN,
    NAMEN: NAMEN,
    FRAGEN: FRAGEN,
    RAHMEN: RAHMEN,
    WEGE: WEGE,
    NUR_X10: NUR_X10,
    abgeleiteterFaktor: abgeleiteterFaktor,
    wegeFuer: wegeFuer,
    familieAusName: familieAusName,
    STANDARD: STANDARD,
    GRENZEN: GRENZEN,
    ANNAHMEN: ANNAHMEN,
    INTERESSE: INTERESSE,
    EMPFEHLUNGEN: EMPFEHLUNGEN,
    SPEICHER: SPEICHER,
    TEXTE: TEXTE,
    zahl: zahl,
    basisAus: basisAus,
    startZustand: startZustand,
    normalisiereZustand: normalisiereZustand,
    nutzungsdauerFuer: nutzungsdauerFuer,
    annahmenFuer: annahmenFuer,
    rechne: rechne,
    kurve: kurve,
    achse: achse,
    textBreite: textBreite,
    kurvenMasse: kurvenMasse,
    achsenLage: achsenLage,
    empfehlung: empfehlung,
    empfehlungsTexte: empfehlungsTexte,
    interesseFuer: interesseFuer,
    produktName: produktName,
    geraeteOptionen: geraeteOptionen,
    kodiere: kodiere,
    dekodiere: dekodiere,
    zahlText: zahlText,
    euro0: euro0,
    euro2: euro2,
    euroPreis: euroPreis,
    prozentText: prozentText,
    faktorText: faktorText,
    monateText: monateText,
    werteTexte: werteTexte,
    annahmenText: annahmenText,
    zusammenfassung: zusammenfassung,
    kurvenText: kurvenText,
    tabellenZeilen: tabellenZeilen,
    tooltipZeilen: tooltipZeilen,
    monatsAnsage: monatsAnsage,
    LEASING_MINDESTRATE: LEASING_MINDESTRATE,
    TISCHGERAETE: TISCHGERAETE,
    istTischgeraet: istTischgeraet,
    mindestrateFuer: mindestrateFuer,
    leasingRate: leasingRate,
    kurzfassung: kurzfassung,
    nachricht: nachricht
  };

  // Node (Tests): nur hier gibt es module.exports, im Browser nie
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    if (typeof module === 'object' && module && module.exports) module.exports = api;
    return;
  }

  // ===========================================================================================
  // Teil 2: Browser
  // ===========================================================================================

  window.__mvSortiment = window.__mvSortiment || {};
  var MV = window.__mvSortiment;
  if (MV.finvergleich) return;
  MV.finvergleich = api;

  var WURZEL = '[data-mv-finv]';
  var WERT_SLOTS = ['monatlich', 'gesamt', 'mehr', 'liquiditaet', 'gleichstand', 'eigentum', 'steuer', 'nachsteuern', 'hinweis'];
  var SVG_NS = 'http://www.w3.org/2000/svg';
  var ANSAGE_MS = 500;
  var instanzen = typeof WeakMap === 'function' ? new WeakMap() : null;
  var alle = [];
  var aktiverDruck = null;
  var zaehler = 0;

  function publiziere(name, daten) {
    try {
      var s = window.Shopify;
      if (s && s.analytics && typeof s.analytics.publish === 'function') s.analytics.publish(name, daten);
    } catch (e) { /* Analytics darf den Vergleich nie stoppen */ }
  }

  function speicherLesen() {
    try {
      return window.localStorage ? window.localStorage.getItem(SPEICHER) : null;
    } catch (e) {
      return null;
    }
  }

  function speicherSchreiben(text) {
    try {
      if (window.localStorage) window.localStorage.setItem(SPEICHER, text);
    } catch (e) { /* privates Fenster oder gesperrter Speicher: Hash genuegt */ }
  }

  // ---- Kundenkonto (Paket A-2b) ----------------------------------------------------------------

  // MVKonto (assets/mv-sortiment.konto.js) steht im Buendel nach dieser Datei: erst beim Aufruf aufloesen. Mit MVKonto
  // speichert der Vergleich nur dort (SPEICHER ist dann Altschluessel fuer die Migration); ohne MVKonto (Rueckfall, etwa
  // beim Rueckweg von A-2a) wie vor A-2b unter SPEICHER.
  function kontoApi() {
    var k = window.MVKonto;
    return k && typeof k.lokal === 'function' && typeof k.speichern === 'function' && typeof k.lesen === 'function' &&
      typeof k.loeschen === 'function' && typeof k.migration === 'function' ? k : null;
  }

  // Altschluessel einmalig in den Spiegel (verschoben, nicht geteilt; ohne Zeitstempel verliert er gegen jeden
  // Konto-Stand): der gespeicherte Hash-Text wird zum code des Stands
  function kontoAnmelden(mv, basis) {
    mv.migration(/^finvergleich$/, {
      geteilt: false,
      alt: function () { return SPEICHER; },
      lesen: function (roh) {
        var z = dekodiere(roh, basis);
        return z ? { v: 1, code: kodiere(z, basis) } : null;
      }
    });
  }

  // Start erst nach dem ganzen Buendel (konto.js steht dahinter): Mikrotask, laeuft vor dem naechsten Zeichnen
  function nachBuendel(fn) {
    if (window.MVKonto || typeof window.Promise !== 'function') fn();
    else window.Promise.resolve().then(fn);
  }

  function bewegungReduziert() {
    try {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    } catch (e) {
      return false;
    }
  }

  function setzeText(el, text) {
    if (el && el.textContent !== text) el.textContent = text;
  }

  function leere(el) {
    while (el && el.firstChild) el.removeChild(el.firstChild);
  }

  function element(name, klasse, text) {
    var el = document.createElement(name);
    if (klasse) el.className = klasse;
    if (text !== null && text !== undefined) el.textContent = text;
    return el;
  }

  function svg(name, attribute, text) {
    var el = document.createElementNS(SVG_NS, name);
    for (var k in attribute) {
      if (hat(attribute, k) && attribute[k] !== null && attribute[k] !== undefined) el.setAttribute(k, String(attribute[k]));
    }
    if (text !== null && text !== undefined) el.textContent = text;
    return el;
  }

  function r1(x) {
    return Math.round(x * 10) / 10;
  }

  // D-W2: Schriftgroesse der Kurve aus der CSS (--mvs-finv-fs-grafik an der Kurvenflaeche); ohne Stile (Tests unter
  // jsdom) 14 px schmal, 16 px breit
  function grafikSchrift(flaeche, schmal) {
    var px = 0;
    try {
      px = parseFloat(window.getComputedStyle(flaeche).fontSize);
    } catch (e) {
      px = 0;
    }
    return px >= 10 && px <= 40 ? px : schmal ? 14 : 16;
  }

  function wurzelVon(el) {
    return el && el.closest ? el.closest(WURZEL) : null;
  }

  function Vergleich(w) {
    this.w = w;
    zaehler += 1;
    this.id = (w.id || 'mv-finv') + '-' + zaehler;
    this.daten = this.datenLesen();
    this.basis = basisAus(this.daten);
    this.gruppen = geraeteOptionen(this.daten);
    this.optionen = {};
    var self = this;
    this.gruppen.forEach(function (g) {
      g.optionen.forEach(function (o) {
        self.optionen[o.wert] = o;
      });
    });
    this.standardWert = this.standardFinden();
    this.z = startZustand(this.basis);
    this.ergebnis = null;
    this.annahmen = null;
    this.monat = null;
    this.zeigerAktiv = false;
    this.geo = null;
    this.letzteEmpfehlung = null;
    this.ansageTimer = 0;
    this.tabelleVorher = null;
  }

  Vergleich.prototype.el = function (selektor) {
    return this.w.querySelector(selektor);
  };

  Vergleich.prototype.alleEl = function (selektor) {
    return Array.prototype.slice.call(this.w.querySelectorAll(selektor));
  };

  Vergleich.prototype.datenLesen = function () {
    var el = this.el('script[data-mv-finv-daten]');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (e) {
      if (window.console && console.warn) console.warn('mv-finv: Datenblock nicht lesbar', e);
      return {};
    }
  };

  // Standardgeraet der Settings in der Geraeteliste (gleicher Name, gleicher Preis) -> keine Dublette
  Vergleich.prototype.standardFinden = function () {
    var name = this.basis.geraetName.toLowerCase();
    for (var k in this.optionen) {
      if (!hat(this.optionen, k)) continue;
      var o = this.optionen[k];
      if (o.name.toLowerCase() === name && Math.abs(o.preis - this.basis.preis) < 0.005) return o.wert;
    }
    return 'standard';
  };

  Vergleich.prototype.option = function () {
    var g = this.z.geraet === 'standard' ? this.standardWert : this.z.geraet;
    return hat(this.optionen, g) ? this.optionen[g] : null;
  };

  Vergleich.prototype.typ = function () {
    var o = this.option();
    if (o) return o.typ;
    return this.z.geraet === 'standard' ? 'snack' : undefined;
  };

  // F-3a: Familie und Wege des gewaehlten Geraets; ein eigener Geraetepreis rechnet wie alle Geraete ausser dem X10
  // (Kauf und Leasing), der Hinweis nennt den Weg zu Mietkauf und Miete
  Vergleich.prototype.familie = function () {
    if (this.z.geraet === 'eigen') return null;
    var o = this.option();
    return o ? o.familie : this.basis.familie;
  };

  Vergleich.prototype.wege = function () {
    return wegeFuer(this.familie());
  };

  // F-5 (03.11.2026): keine Mindestrate - fuer jedes gewaehlte Geraet 0, auch beim eigenen Geraetepreis (F-4:
  // Standautomaten und eigener Preis LEASING_MINDESTRATE, Tischgeraete 0)
  Vergleich.prototype.mindestrate = function () {
    return 0;
  };

  // Sichtbarkeit nach den Wegen: [data-mv-finv-nur-x10] (Karten, Legende, Tabellenspalten, Annahmen Mietkauf/Miete),
  // Spaltenzahl der Karten (data-mv-finv-wege) und der Hinweis zu Kauf und Leasing
  Vergleich.prototype.wegeSetzen = function (wege) {
    var vier = wege.indexOf('miete') !== -1;
    this.alleEl('[data-mv-finv-nur-x10]').forEach(function (el) {
      el.hidden = !vier;
    });
    var liste = this.el('[data-mv-finv-wege]');
    if (liste) liste.setAttribute('data-mv-finv-wege', String(wege.length));
    var hinweis = this.el('[data-mv-finv-wege-hinweis]');
    if (hinweis) {
      setzeText(hinweis, this.z.geraet === 'eigen' ? TEXTE.eigenHinweis : TEXTE.wegeHinweis);
      hinweis.hidden = vier;
    }
  };

  Vergleich.prototype.geraetName = function () {
    if (this.z.geraet === 'eigen') return TEXTE.produktOhne;
    var o = this.option();
    return o ? o.name : this.basis.geraetName;
  };

  Vergleich.prototype.auswahlAufbauen = function () {
    var sel = this.el('[data-mv-finv-geraet]');
    if (!sel) return;
    leere(sel);
    if (this.standardWert === 'standard') {
      var std = element('option', null, this.basis.geraetName + ' \u2013 ' + euroPreis(this.basis.preis) + ' ' + TEXTE.netto);
      std.value = 'standard';
      sel.appendChild(std);
    }
    this.gruppen.forEach(function (g) {
      var gruppe = document.createElement('optgroup');
      gruppe.label = g.titel;
      g.optionen.forEach(function (o) {
        var opt = element('option', null, o.name + ' \u2013 ' + euroPreis(o.preis) + ' ' + TEXTE.netto);
        opt.value = o.wert;
        gruppe.appendChild(opt);
      });
      sel.appendChild(gruppe);
    });
    var eigen = element('option', null, TEXTE.eigenerPreis);
    eigen.value = 'eigen';
    sel.appendChild(eigen);
  };

  Vergleich.prototype.feld = function (name) {
    return this.el('[data-mv-finv-feld="' + name + '"]');
  };

  // Eingaben aus dem Zustand setzen (Geraet, Preis, Laufzeit, Annahmen der gewaehlten Laufzeit, Antworten)
  Vergleich.prototype.eingabenSetzen = function () {
    var z = this.z;
    var sel = this.el('[data-mv-finv-geraet]');
    if (sel) {
      var wert = z.geraet === 'standard' ? this.standardWert : z.geraet;
      var gefunden = false;
      for (var i = 0; i < sel.options.length; i++) if (sel.options[i].value === wert) gefunden = true;
      if (!gefunden) {
        z.geraet = 'eigen';
        wert = 'eigen';
      }
      sel.value = wert;
    }
    var preis = this.feld('preis');
    if (preis) {
      preis.value = zahlKurz(z.preis);
      preis.removeAttribute('aria-invalid');
    }
    this.alleEl('input[type="radio"][data-mv-finv-laufzeit]').forEach(function (r) {
      r.checked = Number(r.value) === z.laufzeit;
    });
    this.annahmenFelderSetzen();
    this.alleEl('input[type="radio"][data-mv-finv-frage]').forEach(function (r) {
      r.checked = z.antworten[r.getAttribute('data-mv-finv-frage')] === r.value;
    });
    this.fehlerZeigen();
  };

  Vergleich.prototype.annahmenFelderSetzen = function () {
    var a = annahmenFuer(this.z, this.basis, this.typ());
    var self = this;
    ANNAHMEN.forEach(function (k) {
      var el = self.feld(k);
      if (!el) return;
      el.value = k === 'leasingFaktor' ? zahlFaktor(a[k]) : zahlKurz(a[k]);
      el.removeAttribute('aria-invalid');
    });
  };

  Vergleich.prototype.fehlerZeigen = function () {
    var fehler = this.el('[data-mv-finv-fehler]');
    if (fehler) fehler.hidden = !this.el('[data-mv-finv-feld][aria-invalid="true"]');
  };

  // Standardwert eines Feldes im aktuellen Zusammenhang (Laufzeit, Geraetetyp)
  Vergleich.prototype.standardWertVon = function (k) {
    if (k === 'leasingFaktor') return this.basis.leasingFaktor[this.z.laufzeit];
    if (k === 'nutzungsdauer') return nutzungsdauerFuer(this.typ(), this.basis);
    return this.basis[k];
  };

  // Eingabe in ein Zahlenfeld: gueltig -> Zustand, ungueltig -> markieren (nur beim Abschluss der Eingabe)
  Vergleich.prototype.feldEingabe = function (el, abschluss) {
    var name = el.getAttribute('data-mv-finv-feld');
    var bereich = name === 'preis' ? 'preis' : name;
    if (!hat(GRENZEN, bereich)) return;
    var w = imBereich(bereich, el.value);
    if (!isFinite(w)) {
      if (abschluss) {
        el.setAttribute('aria-invalid', 'true');
        this.fehlerZeigen();
      }
      return;
    }
    el.removeAttribute('aria-invalid');
    this.fehlerZeigen();
    w = runde2(w);
    var z = this.z;
    var vorher = kodiere(z, this.basis);
    if (name === 'preis') {
      if (Math.abs(w - z.preis) < 0.005) return;
      var o = this.option();
      if (z.geraet !== 'eigen' && (!o || Math.abs(o.preis - w) >= 0.005)) {
        // eigener Preis: die Nutzungsdauer des bisherigen Geraets bleibt stehen
        var typ = this.typ();
        if (!hat(z.eigene, 'nutzungsdauer') && nutzungsdauerFuer(typ, this.basis) !== nutzungsdauerFuer(undefined, this.basis)) z.eigene.nutzungsdauer = nutzungsdauerFuer(typ, this.basis);
        z.geraet = 'eigen';
        var sel = this.el('[data-mv-finv-geraet]');
        if (sel) sel.value = 'eigen';
      }
      z.preis = w;
    } else if (name === 'leasingFaktor') {
      z.eigene.leasingFaktor = z.eigene.leasingFaktor || {};
      if (Math.abs(w - this.standardWertVon(name)) < 1e-9) delete z.eigene.leasingFaktor[z.laufzeit];
      else z.eigene.leasingFaktor[z.laufzeit] = w;
      if (!Object.keys(z.eigene.leasingFaktor).length) delete z.eigene.leasingFaktor;
    } else {
      if (Math.abs(w - this.standardWertVon(name)) < 1e-9) delete z.eigene[name];
      else z.eigene[name] = w;
    }
    // "change" nach "input" mit demselben Wert rechnet nicht ein zweites Mal
    if (kodiere(z, this.basis) === vorher) return;
    this.aktualisieren(true);
  };

  Vergleich.prototype.geraetWaehlen = function (wert) {
    var z = this.z;
    if (wert === 'eigen') {
      z.geraet = 'eigen';
    } else if (wert === 'standard' || wert === this.standardWert) {
      z.geraet = 'standard';
      z.preis = this.option() ? this.option().preis : this.basis.preis;
    } else if (hat(this.optionen, wert)) {
      z.geraet = wert;
      z.preis = this.optionen[wert].preis;
    } else {
      return;
    }
    var preis = this.feld('preis');
    if (preis) {
      preis.value = zahlKurz(z.preis);
      preis.removeAttribute('aria-invalid');
    }
    this.annahmenFelderSetzen();
    this.fehlerZeigen();
    this.aktualisieren(true);
  };

  Vergleich.prototype.laufzeitWaehlen = function (n) {
    if (!istLaufzeit(n) || n === this.z.laufzeit) return;
    this.z.laufzeit = n;
    this.annahmenFelderSetzen();
    this.fehlerZeigen();
    this.aktualisieren(true);
  };

  Vergleich.prototype.antworten = function (frage, wert) {
    if (FRAGEN.indexOf(frage) === -1 || (wert !== 'ja' && wert !== 'nein')) return;
    this.z.antworten[frage] = wert;
    this.aktualisieren(true);
  };

  Vergleich.prototype.annahmenZuruecksetzen = function () {
    this.z.eigene = {};
    this.annahmenFelderSetzen();
    this.fehlerZeigen();
    this.aktualisieren(true);
  };

  Vergleich.prototype.linkText = function () {
    var l = window.location;
    return l.origin + l.pathname + l.search + '#' + kodiere(this.z, this.basis);
  };

  Vergleich.prototype.zustandSchreiben = function () {
    var text = kodiere(this.z, this.basis);
    try {
      var l = window.location;
      window.history.replaceState(window.history.state, '', l.pathname + l.search + '#' + text);
    } catch (e) { /* ohne History-API bleibt der Speicher */ }
    if (this.konto) this.kontoSpeichern(false);
    else speicherSchreiben(text);
  };

  // ---- Kundenkonto (Paket A-2b) ----------------------------------------------------------------

  Vergleich.prototype.kontoTitelName = function () {
    return this.z.geraet === 'eigen' ? TEXTE.eigenerPreis : this.geraetName();
  };

  // Statuszeile binden (aus dem Snippet der Sektion; fehlt es, baut MVKonto die Zeile am Ende des Kopftexts); mit Login
  // den Konto-Stand abgleichen
  Vergleich.prototype.kontoStart = function (mv) {
    var self = this;
    this.kontoText = JSON.stringify(kontoStand(this.z, this.basis, this.kontoTitelName()));
    var box = this.el('[data-mv-konto-hinweis]') || this.el('.mv-finv-kopf__text');
    if (box && typeof mv.hinweis === 'function') mv.hinweis(box, KONTO_WERKZEUG);
    if (typeof mv.eingeloggt !== 'function' || !mv.eingeloggt()) return;
    mv.lesen(KONTO_WERKZEUG).then(function (r) { self.kontoAbgleich(r); }, function () { /* Konto nicht erreichbar: Browser-Stand gilt */ });
  };

  // Antwort des Kontos: abweichender Stand (anderes Geraet) oder im Konto geloescht. Auf der Seite schon geaendert:
  // die Seite gilt und geht wieder ins Konto (auch bei nachgehender Geraeteuhr). Aus einem Link (Hash): der Link gilt.
  // Sonst zeigt die Seite den Konto-Stand bzw. den Standard (ohne Hash zu schreiben, wie beim Laden).
  Vergleich.prototype.kontoAbgleich = function (r) {
    if (!r || (!r.neu && !r.verworfen)) return;
    if (this.geaendert) {
      this.kontoSpeichern(true);
      return;
    }
    if (this.ausLink) return;
    var z = r.verworfen ? null : kontoStandPruefen(r.stand, this.basis);
    this.z = z || startZustand(this.basis);
    this.eingabenSetzen();
    this.aktualisieren(false);
    this.kontoText = JSON.stringify(kontoStand(this.z, this.basis, this.kontoTitelName()));
  };

  // Ganzer Stand in Spiegel und Konto, nur bei einer echten Aenderung (immer = nach dem Abgleich, die Seite gilt)
  Vergleich.prototype.kontoSpeichern = function (immer) {
    var s = kontoStand(this.z, this.basis, this.kontoTitelName());
    var t = JSON.stringify(s);
    if (!immer && t === this.kontoText) return;
    this.kontoText = t;
    this.geaendert = true;
    this.konto.speichern(KONTO_WERKZEUG, s);
  };

  // Rechnen und alles Sichtbare setzen; schreiben = Zustand in Hash und Speicher (nicht beim Laden)
  Vergleich.prototype.aktualisieren = function (schreiben) {
    var wege = this.wege();
    var a = annahmenFuer(this.z, this.basis, this.typ());
    var e = rechne(a, wege, this.mindestrate());
    this.annahmen = a;
    this.ergebnis = e;
    var emp = empfehlung(this.z.antworten, wege);
    this.wegeSetzen(wege);
    this.kartenSetzen(e, emp);
    setzeText(this.el('[data-mv-finv-slot="annahmen"]'), e ? annahmenText(a, wege) : TEXTE.kurveLeer);
    this.kurveZeichnen(e, emp ? emp.variante : null);
    this.tabelleSetzen(e);
    this.empfehlungSetzen(emp, e, schreiben);
    this.ctaSetzen(emp);
    this.ansageSetzen(e);
    if (schreiben) this.zustandSchreiben();
  };

  Vergleich.prototype.kartenSetzen = function (e, emp) {
    var texte = werteTexte(e);
    var self = this;
    VARIANTEN.forEach(function (v) {
      var karte = self.el('[data-mv-finv-variante="' + v + '"]');
      if (!karte) return;
      WERT_SLOTS.forEach(function (slot) {
        var el = karte.querySelector('[data-mv-finv-wert="' + slot + '"]');
        if (!el) return;
        var text = texte[v][slot];
        setzeText(el, text);
        if (slot === 'hinweis') el.hidden = !text;
      });
      var empfohlen = !!emp && emp.variante === v;
      if (empfohlen) karte.setAttribute('data-mv-finv-empfohlen', '');
      else karte.removeAttribute('data-mv-finv-empfohlen');
      var badge = karte.querySelector('[data-mv-finv-badge]');
      if (badge) badge.hidden = !empfohlen;
    });
  };

  Vergleich.prototype.tabelleSetzen = function (e) {
    var rumpf = this.el('[data-mv-finv-tabelle-rumpf]');
    if (!rumpf) return;
    leere(rumpf);
    tabellenZeilen(e).forEach(function (z) {
      var tr = document.createElement('tr');
      var th = element('th', null, z.label);
      th.setAttribute('scope', 'row');
      tr.appendChild(th);
      // F-3a: Spalten nur fuer die Wege des Geraets (die Kopfzellen der anderen tragen hidden)
      wegeVon(e).forEach(function (v) {
        tr.appendChild(element('td', null, z.werte[v]));
      });
      rumpf.appendChild(tr);
    });
  };

  Vergleich.prototype.empfehlungSetzen = function (emp, e, meldung) {
    var leer = this.el('[data-mv-finv-slot="empfehlung-leer"]');
    var inhalt = this.el('[data-mv-finv-slot="empfehlung"]');
    if (leer) leer.hidden = !!emp;
    if (inhalt) inhalt.hidden = !emp;
    var t = empfehlungsTexte(emp, e);
    setzeText(this.el('[data-mv-finv-slot="empfehlung-titel"]'), t.titel);
    setzeText(this.el('[data-mv-finv-slot="empfehlung-grund"]'), t.grund);
    setzeText(this.el('[data-mv-finv-slot="empfehlung-zahlen"]'), t.zahlen);
    setzeText(this.el('[data-mv-finv-slot="empfehlung-alternative"]'), t.alternative);
    this.alleEl('[data-mv-finv-empfehlung-icon]').forEach(function (el) {
      el.hidden = !emp || el.getAttribute('data-mv-finv-empfehlung-icon') !== emp.variante;
    });
    var schluessel = emp ? emp.variante : null;
    if (schluessel !== this.letzteEmpfehlung) {
      if (meldung && emp) publiziere('finanzierungsvergleich_empfehlung', { variante: emp.variante, alternative: emp.alternative, laufzeit: this.z.laufzeit });
      this.letzteEmpfehlung = schluessel;
    }
  };

  Vergleich.prototype.ctaSetzen = function (emp) {
    var cta = this.el('[data-mv-finv-cta]');
    if (!cta) return;
    var interesse = interesseFuer(emp ? emp.variante : null);
    var produkt = this.geraetName();
    var info = { zustand: this.z, annahmen: this.annahmen, ergebnis: this.ergebnis, empfehlung: emp, geraetName: produkt, link: this.linkText() };
    var konf = kurzfassung(info);
    cta.setAttribute('data-interesse', interesse);
    cta.setAttribute('data-produkt', produkt);
    cta.setAttribute('data-konfiguration', konf);
    cta.setAttribute('data-nachricht', nachricht(info));
    cta.setAttribute('href', '/pages/contact?anfrage=1&interesse=' + encodeURIComponent(interesse) + '&produkt=' + encodeURIComponent(produkt) + '&konfiguration=' + encodeURIComponent(konf));
  };

  Vergleich.prototype.ansageSetzen = function (e) {
    var el = this.el('[data-mv-finv-ansage]');
    if (!el) return;
    if (this.ansageTimer) window.clearTimeout(this.ansageTimer);
    var text = zusammenfassung(e);
    this.ansageTimer = window.setTimeout(function () {
      setzeText(el, text);
    }, ANSAGE_MS);
  };

  // ------------------------------------------------------------------ Kurve (SVG ohne Bibliothek)

  Vergleich.prototype.kurveZeichnen = function (e, betont) {
    var flaeche = this.el('[data-mv-finv-kurve-flaeche]');
    if (!flaeche) return;
    leere(flaeche);
    this.geo = null;
    if (!e) {
      flaeche.appendChild(element('p', 'mv-finv-kurve__leer', TEXTE.kurveLeer));
      flaeche.removeAttribute('tabindex');
      this.tooltipVerbergen();
      return;
    }
    var breite = Math.round(flaeche.clientWidth || 0);
    if (!(breite >= 260)) breite = 640;
    // schmal (mobil): Achsenwerte ueber den Gitterlinien statt links daneben, Endmarken nur mit Namen
    var schmal = breite < 520;
    var n = e.laufzeit;
    var k = kurve(e);
    // F-3a: nur die Wege des Geraets (beim SandenVendo-Geraet Kauf und Leasing)
    var wege = wegeVon(e);
    var max = 0;
    wege.forEach(function (v) {
      max = Math.max(max, e[v].gesamt, e[v].start);
    });
    var ax = achse(max);
    var marken = wege.map(function (v) {
      return { v: v, y0: 0, y: 0, text: NAMEN[v] + (schmal ? '' : ' ' + euro0(e[v].gesamt)) };
    });
    // D-W2: Schrift aus der CSS; Raender, Abstaende und Hoehe aus ihr und den Texten (kurvenMasse)
    var masse = kurvenMasse(breite, grafikSchrift(flaeche, schmal), ax.ticks.map(euro0), marken.map(function (mk) { return mk.text; }));
    var fs = masse.fs;
    var hoehe = masse.hoehe;
    var rand = masse.rand;
    var pw = masse.pw;
    var ph = masse.ph;
    var x = function (m) { return rand.l + (n > 0 ? (m / n) * pw : 0); };
    var y = function (w) { return rand.o + ph - (ax.max > 0 ? (w / ax.max) * ph : 0); };
    var id = this.id + '-kurve';
    var bild = svg('svg', { class: 'mv-finv-kurve__svg', viewBox: '0 0 ' + breite + ' ' + hoehe, width: breite, height: hoehe, 'font-size': masse.fs, role: 'img', 'aria-labelledby': id + '-titel ' + id + '-text', focusable: 'false' });
    bild.appendChild(svg('title', { id: id + '-titel' }, TEXTE.kurveTitel));
    bild.appendChild(svg('desc', { id: id + '-text' }, kurvenText(e)));
    var innenWerte = [];
    ax.ticks.forEach(function (t) {
      bild.appendChild(svg('line', { class: 'mv-finv-kurve__gitter', x1: rand.l, x2: rand.l + pw, y1: r1(y(t)), y2: r1(y(t)) }));
      if (!schmal) bild.appendChild(svg('text', { class: 'mv-finv-kurve__achse-text', x: rand.l - 8, y: r1(y(t) + masse.mitte), 'text-anchor': 'end' }, euro0(t)));
    });
    // mobil (K-A): Achsenwerte in der Flaeche ueber oder unter ihrer Gitterlinie (achsenLage), die Grundflaeche haelt
    // die Gitterlinie vom Wert fern
    if (schmal) {
      achsenLage(e, masse, ax).forEach(function (lage) {
        var wert = euro0(lage.wert);
        innenWerte.push(svg('rect', { class: 'mv-finv-kurve__achse-grund', x: rand.l - 2, y: r1(lage.grundlinie - masse.grund), width: Math.ceil(textBreite(wert, fs) + 6), height: masse.grund + 3, rx: 2 }));
        innenWerte.push(svg('text', { class: 'mv-finv-kurve__achse-text', x: rand.l + 1, y: lage.grundlinie, 'text-anchor': 'start' }, wert));
      });
    }
    bild.appendChild(svg('line', { class: 'mv-finv-kurve__grundlinie', x1: rand.l, x2: rand.l + pw, y1: rand.o + ph, y2: rand.o + ph }));
    for (var m = 0; m <= n; m += 12) {
      bild.appendChild(svg('text', { class: 'mv-finv-kurve__achse-text', x: r1(x(m)), y: rand.o + ph + masse.xAchse, 'text-anchor': 'middle' }, String(m)));
    }
    bild.appendChild(svg('text', { class: 'mv-finv-kurve__achse-titel', x: rand.l + pw, y: rand.o + ph + masse.titel, 'text-anchor': 'end' }, TEXTE.achseMonate));
    // K-A: mobil die Achsenwerte vor den Linien zeichnen; die Linien laufen darueber und werden nie unterbrochen
    innenWerte.forEach(function (t) {
      bild.appendChild(t);
    });
    wege.forEach(function (v) {
      var d = k.monate.map(function (mo, i) {
        return (i ? 'L' : 'M') + r1(x(mo)) + ' ' + r1(y(k.reihen[v][i]));
      }).join(' ');
      bild.appendChild(svg('path', { class: 'mv-finv-kurve__linie mv-finv-kurve__linie--' + v + (v === betont ? ' mv-finv-kurve__linie--betont' : ''), d: d }));
    });
    // Endpunkte und Beschriftung am Ende; liegen Enden dicht beieinander, fuehren Leitlinien zur Marke
    marken.forEach(function (mk) {
      mk.y0 = y(e[mk.v].gesamt);
      mk.y = mk.y0;
    });
    marken.sort(function (p, q) { return p.y0 - q.y0; });
    var abstand = masse.abstand;
    var oben = rand.o + 6;
    var unten = rand.o + ph;
    for (var i = 0; i < marken.length; i++) {
      marken[i].y = Math.max(marken[i].y0, oben);
      if (i > 0) marken[i].y = Math.max(marken[i].y, marken[i - 1].y + abstand);
    }
    var letzte = marken.length - 1;
    if (letzte >= 0 && marken[letzte].y > unten) {
      marken[letzte].y = unten;
      for (var j = letzte - 1; j >= 0; j--) marken[j].y = Math.min(marken[j].y, marken[j + 1].y - abstand);
    }
    var xe = x(n);
    marken.forEach(function (mk) {
      if (Math.abs(mk.y - mk.y0) > 1) bild.appendChild(svg('line', { class: 'mv-finv-kurve__leiter', x1: r1(xe + 6), y1: r1(mk.y0), x2: r1(xe + 14), y2: r1(mk.y) }));
      bild.appendChild(svg('circle', { class: 'mv-finv-kurve__endpunkt mv-finv-kurve__endpunkt--' + mk.v, cx: r1(xe), cy: r1(mk.y0), r: 4 }));
      bild.appendChild(svg('text', { class: 'mv-finv-kurve__marke', x: r1(xe + 16), y: r1(mk.y + masse.mitte) }, mk.text));
    });
    var kreuz = svg('g', { class: 'mv-finv-kurve__fadenkreuz', hidden: '' });
    kreuz.appendChild(svg('line', { class: 'mv-finv-kurve__fadenkreuz-linie', x1: rand.l, x2: rand.l, y1: rand.o, y2: rand.o + ph }));
    wege.forEach(function (v) {
      kreuz.appendChild(svg('circle', { class: 'mv-finv-kurve__fadenkreuz-punkt mv-finv-kurve__endpunkt--' + v, cx: rand.l, cy: rand.o + ph, r: 4 }));
    });
    bild.appendChild(kreuz);
    flaeche.appendChild(bild);
    flaeche.setAttribute('tabindex', '0');
    this.geo = { breite: breite, fs: fs, rand: rand, pw: pw, ph: ph, n: n, x: x, y: y, kreuz: kreuz, k: k };
    if (this.monat !== null && this.tooltipOffen()) this.zeigeMonat(this.monat);
  };

  Vergleich.prototype.tooltipOffen = function () {
    var tip = this.el('[data-mv-finv-tooltip]');
    return !!tip && !tip.hidden;
  };

  // ansagen: Tastatur und Fokus (nicht der Zeiger) sagen den Monat ueber [data-mv-finv-kurve-ansage] an; der Tooltip
  // selbst ist rein visuell und keine Live-Region (verborgene Live-Regionen verschlucken die erste Ansage)
  Vergleich.prototype.zeigeMonat = function (monat, ansagen) {
    var e = this.ergebnis;
    var geo = this.geo;
    var tip = this.el('[data-mv-finv-tooltip]');
    if (!e || !geo || !tip) return;
    var m = Math.max(0, Math.min(geo.n, Math.round(monat)));
    this.monat = m;
    var xm = geo.x(m);
    var linie = geo.kreuz.querySelector('.mv-finv-kurve__fadenkreuz-linie');
    linie.setAttribute('x1', r1(xm));
    linie.setAttribute('x2', r1(xm));
    var punkte = geo.kreuz.querySelectorAll('.mv-finv-kurve__fadenkreuz-punkt');
    wegeVon(e).forEach(function (v, i) {
      if (!punkte[i]) return;
      punkte[i].setAttribute('cx', r1(xm));
      punkte[i].setAttribute('cy', r1(geo.y(geo.k.reihen[v][m])));
    });
    geo.kreuz.removeAttribute('hidden');
    var t = tooltipZeilen(e, m);
    leere(tip);
    tip.appendChild(element('p', 'mv-finv-kurve__tip-titel', t.titel));
    tip.appendChild(document.createTextNode(' '));
    var liste = element('ul', 'mv-finv-kurve__tip-liste');
    liste.setAttribute('role', 'list');
    t.zeilen.forEach(function (z) {
      var li = element('li', 'mv-finv-kurve__tip-zeile');
      var schluessel = element('span', 'mv-finv-kurve__tip-schluessel mv-finv-kurve__tip-schluessel--' + z.id);
      schluessel.setAttribute('aria-hidden', 'true');
      li.appendChild(schluessel);
      li.appendChild(element('strong', 'mv-finv-kurve__tip-wert', z.wert));
      li.appendChild(document.createTextNode(' '));
      li.appendChild(element('span', 'mv-finv-kurve__tip-name', z.name));
      li.appendChild(document.createTextNode(' '));
      liste.appendChild(li);
    });
    tip.appendChild(liste);
    var anteil = geo.breite > 0 ? xm / geo.breite : 0;
    tip.style.setProperty('--mvs-finv-tip-anteil', String(Math.round(anteil * 1000) / 1000));
    if (anteil > 0.55) tip.classList.add('mv-finv-kurve__tooltip--links');
    else tip.classList.remove('mv-finv-kurve__tooltip--links');
    tip.hidden = false;
    var ansage = this.el('[data-mv-finv-kurve-ansage]');
    if (ansagen && ansage) setzeText(ansage, monatsAnsage(e, m));
  };

  Vergleich.prototype.tooltipVerbergen = function () {
    var tip = this.el('[data-mv-finv-tooltip]');
    if (tip) tip.hidden = true;
    if (this.geo && this.geo.kreuz) this.geo.kreuz.setAttribute('hidden', '');
    this.zeigerAktiv = false;
  };

  Vergleich.prototype.monatAusZeiger = function (ereignis, flaeche) {
    var geo = this.geo;
    if (!geo) return null;
    var rect = flaeche.getBoundingClientRect ? flaeche.getBoundingClientRect() : { left: 0, width: 0 };
    var massstab = rect.width > 0 ? geo.breite / rect.width : 1;
    var xv = (ereignis.clientX - rect.left) * massstab;
    return Math.round(((xv - geo.rand.l) / geo.pw) * geo.n);
  };

  Vergleich.prototype.taste = function (ereignis) {
    if (!this.geo) return;
    var m = this.monat === null ? this.geo.n : this.monat;
    var neu = null;
    switch (ereignis.key) {
      case 'ArrowLeft':
      case 'ArrowDown':
        neu = m - 1;
        break;
      case 'ArrowRight':
      case 'ArrowUp':
        neu = m + 1;
        break;
      case 'PageUp':
        neu = m + 12;
        break;
      case 'PageDown':
        neu = m - 12;
        break;
      case 'Home':
        neu = 0;
        break;
      case 'End':
        neu = this.geo.n;
        break;
      case 'Escape':
        this.tooltipVerbergen();
        return;
      default:
        return;
    }
    ereignis.preventDefault();
    this.zeigeMonat(neu, true);
  };

  // ------------------------------------------------------------------ Druck, Link, Sprung

  Vergleich.prototype.druckVorbereiten = function () {
    aktiverDruck = this;
    document.documentElement.setAttribute('data-mv-finv-druck', '');
    var tabelle = this.el('[data-mv-finv-tabelle]');
    if (tabelle) {
      this.tabelleVorher = !!tabelle.open;
      tabelle.open = true;
    }
  };

  Vergleich.prototype.druckEnde = function () {
    document.documentElement.removeAttribute('data-mv-finv-druck');
    var tabelle = this.el('[data-mv-finv-tabelle]');
    if (tabelle && this.tabelleVorher !== null) tabelle.open = this.tabelleVorher;
    this.tabelleVorher = null;
    if (aktiverDruck === this) aktiverDruck = null;
  };

  Vergleich.prototype.drucken = function () {
    this.druckVorbereiten();
    try {
      window.print();
    } catch (e) {
      this.druckEnde();
    }
  };

  Vergleich.prototype.status = function (text) {
    setzeText(this.el('[data-mv-finv-status]'), text);
  };

  Vergleich.prototype.linkKopieren = function () {
    var self = this;
    this.zustandSchreiben();
    var url = window.location.href;
    var ablage = window.navigator && window.navigator.clipboard;
    if (ablage && typeof ablage.writeText === 'function') {
      ablage.writeText(url).then(function () {
        self.status(TEXTE.linkKopiert);
      }, function () {
        self.status(TEXTE.linkManuell);
      });
    } else {
      this.status(TEXTE.linkManuell);
    }
  };

  // Fokus nach dem Sprung (K-2, Querpruefung Abschnitt 5): Ueberschrift mit tabindex -1 am oder im Ziel, bei den
  // Annahmen (details) die summary; preventScroll, weil scrollIntoView den Weg schon (sanft) geht
  function sprungFokus(ziel) {
    if (ziel.tagName === 'DETAILS') return ziel.querySelector('summary');
    if (ziel.getAttribute('tabindex') === '-1') return ziel;
    return ziel.querySelector('[tabindex="-1"]');
  }

  Vergleich.prototype.springe = function (link) {
    var ziel = document.getElementById((link.getAttribute('href') || '').replace(/^#/, ''));
    if (!ziel) return;
    if (ziel.tagName === 'DETAILS') ziel.open = true;
    if (typeof ziel.scrollIntoView === 'function') ziel.scrollIntoView({ behavior: bewegungReduziert() ? 'auto' : 'smooth', block: 'start' });
    var fokus = sprungFokus(ziel);
    if (!fokus || typeof fokus.focus !== 'function') return;
    try {
      fokus.focus({ preventScroll: true });
    } catch (e) {
      fokus.focus();
    }
  };

  Vergleich.prototype.start = function () {
    this.auswahlAufbauen();
    var ausHash = dekodiere(window.location.hash, this.basis);
    // A-2b: mit MVKonto kommt der gespeicherte Stand aus dem Spiegel (Altschluessel einmalig uebernommen)
    var mv = kontoApi();
    if (mv) kontoAnmelden(mv, this.basis);
    this.konto = mv;
    this.geaendert = false;
    this.ausLink = !!ausHash;
    var gespeichert = ausHash ? null : dekodiere(mv ? this.kontoCode(mv) : speicherLesen(), this.basis);
    if (ausHash) this.z = ausHash;
    else if (gespeichert) this.z = gespeichert;
    this.eingabenSetzen();
    this.aktualisieren(false);
    this.alleEl('[data-mv-finv-drucken], [data-mv-finv-link]').forEach(function (el) {
      el.hidden = false;
    });
    this.w.setAttribute('data-mv-finv-bereit', '');
    if (ausHash && typeof this.w.scrollIntoView === 'function') {
      try {
        this.w.scrollIntoView({ block: 'start' });
      } catch (e) { /* aeltere Browser */ }
    }
    if (mv) this.kontoStart(mv);
  };

  // Spiegel synchron lesen (migriert den Altschluessel beim ersten Mal) -> Hash-Text oder null
  Vergleich.prototype.kontoCode = function (mv) {
    var e = mv.lokal(KONTO_WERKZEUG);
    var s = e && istObjekt(e.stand) && e.stand.v === 1 && typeof e.stand.code === 'string' ? e.stand.code : null;
    return s;
  };

  function instanz(wurzel) {
    if (!wurzel) return null;
    if (instanzen) return instanzen.get(wurzel) || null;
    for (var i = 0; i < alle.length; i++) if (alle[i].w === wurzel) return alle[i];
    return null;
  }

  function starte(wurzel) {
    if (!wurzel || instanz(wurzel)) return;
    var v = new Vergleich(wurzel);
    if (instanzen) instanzen.set(wurzel, v);
    alle.push(v);
    v.start();
    beobachteGroesse(v);
  }

  function alleStarten(bereich) {
    var b = bereich && bereich.querySelectorAll ? bereich : document;
    if (b.matches && b.matches(WURZEL)) starte(b);
    var liste = b.querySelectorAll(WURZEL);
    for (var i = 0; i < liste.length; i++) starte(liste[i]);
  }

  // Neu zeichnen, wenn sich die Breite der Kurve aendert (ResizeObserver, sonst resize auf window); D-W2: auch wenn
  // sich die Schrift der Flaeche geaendert hat (Breakpoints 1000 und 1280 px)
  var groessenTimer = 0;
  var beobachter = typeof window.ResizeObserver === 'function' ? new window.ResizeObserver(function (eintraege) {
    eintraege.forEach(function (eintrag) {
      var v = instanz(wurzelVon(eintrag.target));
      if (!v || !v.geo) return;
      var breite = eintrag.target.clientWidth || 0;
      if (Math.abs(breite - v.geo.breite) > 4 || grafikSchrift(eintrag.target, breite < 520) !== v.geo.fs) v.kurveZeichnen(v.ergebnis, v.letzteEmpfehlung);
    });
  }) : null;

  function beobachteGroesse(v) {
    var flaeche = v.el('[data-mv-finv-kurve-flaeche]');
    if (beobachter && flaeche) beobachter.observe(flaeche);
  }

  if (!beobachter) {
    window.addEventListener('resize', function () {
      if (groessenTimer) window.clearTimeout(groessenTimer);
      groessenTimer = window.setTimeout(function () {
        alle.forEach(function (v) {
          if (v.geo) v.kurveZeichnen(v.ergebnis, v.letzteEmpfehlung);
        });
      }, 150);
    });
  }

  function vergleichVon(el) {
    return instanz(wurzelVon(el));
  }

  document.addEventListener('input', function (ereignis) {
    var el = ereignis.target;
    if (!el || !el.hasAttribute || !el.hasAttribute('data-mv-finv-feld')) return;
    var v = vergleichVon(el);
    if (v) v.feldEingabe(el, false);
  });

  document.addEventListener('change', function (ereignis) {
    var el = ereignis.target;
    if (!el || !el.hasAttribute) return;
    var v = vergleichVon(el);
    if (!v) return;
    if (el.hasAttribute('data-mv-finv-feld')) v.feldEingabe(el, true);
    else if (el.hasAttribute('data-mv-finv-geraet')) v.geraetWaehlen(el.value);
    else if (el.hasAttribute('data-mv-finv-laufzeit') && el.checked) v.laufzeitWaehlen(Number(el.value));
    else if (el.hasAttribute('data-mv-finv-frage') && el.checked) v.antworten(el.getAttribute('data-mv-finv-frage'), el.value);
  });

  document.addEventListener('submit', function (ereignis) {
    var form = ereignis.target;
    if (form && form.matches && form.matches('[data-mv-finv-form]')) ereignis.preventDefault();
  });

  document.addEventListener('click', function (ereignis) {
    var ziel = ereignis.target;
    var v = vergleichVon(ziel);
    if (!v || !ziel.closest) return;
    if (ziel.closest('[data-mv-finv-zuruecksetzen]')) {
      ereignis.preventDefault();
      v.annahmenZuruecksetzen();
      return;
    }
    if (ziel.closest('[data-mv-finv-drucken]')) {
      ereignis.preventDefault();
      v.drucken();
      return;
    }
    if (ziel.closest('[data-mv-finv-link]')) {
      ereignis.preventDefault();
      v.linkKopieren();
      return;
    }
    var sprung = ziel.closest('[data-mv-finv-sprung]');
    if (sprung) {
      ereignis.preventDefault();
      v.springe(sprung);
      return;
    }
    if (ziel.closest('[data-mv-finv-cta]')) {
      var emp = empfehlung(v.z.antworten, v.wege());
      publiziere('finanzierungsvergleich_cta', { variante: emp ? emp.variante : null, laufzeit: v.z.laufzeit, preis: v.z.preis, geraet: v.geraetName() });
    }
  });

  document.addEventListener('keydown', function (ereignis) {
    var el = ereignis.target;
    if (!el || !el.hasAttribute || !el.hasAttribute('data-mv-finv-kurve-flaeche')) return;
    var v = vergleichVon(el);
    if (v) v.taste(ereignis);
  });

  document.addEventListener('focusin', function (ereignis) {
    var el = ereignis.target;
    if (!el || !el.hasAttribute || !el.hasAttribute('data-mv-finv-kurve-flaeche')) return;
    var v = vergleichVon(el);
    if (v && v.geo) v.zeigeMonat(v.monat === null ? v.geo.n : v.monat, true);
  });

  document.addEventListener('focusout', function (ereignis) {
    var el = ereignis.target;
    if (!el || !el.hasAttribute || !el.hasAttribute('data-mv-finv-kurve-flaeche')) return;
    var v = vergleichVon(el);
    if (v) v.tooltipVerbergen();
  });

  // Zeiger und Antippen: das Fadenkreuz sucht den naechsten Monat; ausserhalb der Flaeche schliesst der Tooltip
  function zeiger(ereignis) {
    var ziel = ereignis.target;
    var flaeche = ziel && ziel.closest ? ziel.closest('[data-mv-finv-kurve-flaeche]') : null;
    if (flaeche) {
      var v = vergleichVon(flaeche);
      if (!v || !v.geo) return;
      var m = v.monatAusZeiger(ereignis, flaeche);
      if (m === null || !isFinite(m)) return;
      v.zeigerAktiv = true;
      v.zeigeMonat(m);
      return;
    }
    alle.forEach(function (x) {
      if (x.zeigerAktiv || x.tooltipOffen()) {
        if (!(ziel && ziel.closest && ziel.closest('[data-mv-finv-tooltip]'))) x.tooltipVerbergen();
      }
    });
  }

  document.addEventListener('pointermove', zeiger);
  document.addEventListener('pointerdown', zeiger);

  document.addEventListener('shopify:section:load', function (ereignis) {
    alleStarten(ereignis.target);
  });

  // Druck: der Knopf und Strg+P drucken den Vergleich
  window.addEventListener('beforeprint', function () {
    if (aktiverDruck) return;
    for (var i = 0; i < alle.length; i++) {
      if (alle[i].ergebnis && document.documentElement.contains(alle[i].w)) {
        alle[i].druckVorbereiten();
        return;
      }
    }
  });

  window.addEventListener('afterprint', function () {
    if (aktiverDruck) aktiverDruck.druckEnde();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { nachBuendel(function () { alleStarten(document); }); });
  } else {
    nachBuendel(function () { alleStarten(document); });
  }
})();
